import {feats,spells,} from "../data.js"
export const races = [
    {
        rarity:"class",
        name:"Human",
        longDesc:`Humans are generalists, with no special abilities, their strength relies on the talents and training they went through in their life.
        \nAbility Scores: 2 ability scores rolls
        \nDefenses: 1 misc stat roll
        \nSkills: 3 skill rolls
        \nSpecial: Roll1.5x Feat, Common Perk
        \nSize: Medium
        \nSpeed: 30 feet
        \nVision: Normal
        \nBonus Rolls: Every 8 levels gain a feat, every 6 levels gain a skill roll`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"feats"}));
            }
            if(context.stats.characterStats.misc.level %6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"skills"}));
            }
            if(context.stats.characterStats.misc.level %4 == 0 && context.stats.lists.feats.find(feat=>feat.name == "Human Fighter")){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{sterlingSovereignty:true}}}))
            }
        },
        catchUpMethod:(context,self)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"perk", options:{rarity:{common:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"feats", rollAmount:5}));
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{misc:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
            if(context.stats.characterStats.misc.class == "Fighter"){
                self.getChoice(context)
            }
        },
        getChoice: (context)=>{       
            let choices = []
            choices[0] = {
                title:"Human Fighter",
                description:`Gain the Human Fighter Feat:
                \nIncrease the armor bonus you gain from heavy armor by +1.
                \nIncrease the shield bonus you gain from shields with at least a +2 base shield bonus by +1.
                \nIncrease the damage you deal with one handed weapons by +1 as long as you have a shield in the other hand.
                \nIncrease the damage you deal with two-handed weapons by +3.
                \nYou gain a +1 bonus on saves vs spells.
                \nOnce per run you can turn any normal hit with a one or two handed weapon into a critical threat.
                \nYou gain a Sterling Sovereignty maneuver at 1st and every 4 levels.
                \nYou are gigachad
                \nIf you are wearing light or no armor, you take a -2 penalty to armor class.
                \nLight weapons have their damage reduced by -2. Ranged weapons have their damage reduced by -1.
                \nSpells cost 2x the normal spell points.`,
                id:0, 
                method:(context=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{sterlingSovereignty:true}}}))
                    let humanFighter = {name:"Human Fighter", type:"feats", uiType:"feats", longDesc:`Gain the 'Human Fighter' Feat:
                    \nIncrease the armor bonus you gain from heavy armor by +1.
                    \nIncrease the shield bonus you gain from shields with at least a +2 base shield bonus by +1.
                    \nIncrease the damage you deal with one handed weapons by +1 as long as you have a shield in the other hand.
                    \nIncrease the damage you deal with two-handed weapons by +3.
                    \nYou gain a +1 bonus on saves vs spells.
                    \nOnce per run you can turn any normal hit with a one or two-handed weapon into a critical threat.
                    \nYou gain a Sterling Sovereignty maneuver at 1st and every 4 levels.
                    \nYou are gigachad
                    \nIf you are wearing light or no armor, you take a -2 penalty to armor class.
                    \nLight weapons have their damage reduced by -2. Ranged weapons have their damage reduced by -1.
                    \nSpells cost 2x the normal spell points.`}
                    context.stats.lists.feats.push(humanFighter)
                })
            }
            choices[1] = {
                title:"Generalist",
                id:1, 
                description:"You're nothing special...",
                method:(context=>{
                    context.doesNothing = "does nothing"
                })
            }
            
            let custom = {title:"Human Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity:"class",
        name:"Dwarf",
        longDesc:`Dwarves are a sturdy and durable undergrown race, they are resistant to magic, and make some of the best crafstman in the land, but their bullheaded nature leads them to be less friendly.
        \nAbility Scores: +2 Constitution, +1 Wisdom, -2 Charisma
        \nDefenses: +2 bonus on saving throws against spells and poisons, +4 CMD vs trip and bullrush, +2 dodge AC against creatures at least 2 sizes larger than them.
        \nSkills: +6 craft, +4 sense motive, +2 climb, -4 spellcraft, knowledge arcana, diplomacy, fly
        \nSpecial: When using a blanched weapon you gain +1 attack and +2 damage. Gain 10 positive spell power.
        \nSize: Medium
        \nSpeed: 20 feet, but it is not reduced by armor or encumbrance
        \nVision: Darkvision
        \nBonus Rolls: Gain an armor roll. Every 8 levels gain an armor enchantment`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"armor"}));
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.craft += 6
            context.stats.characterStats.skills.senseMotive += 4
            context.stats.characterStats.skills.climb += 2
            context.stats.characterStats.skills.spellcraft -= 4
            context.stats.characterStats.skills.knowArcana -= 4
            context.stats.characterStats.skills.diplomacy -= 4
            context.stats.characterStats.skills.fly -= 4
            context.stats.characterStats.spellMastery.spellPower.positive += 10
        },
    },
    {
        rarity:"class",
        name:"Elf",
        longDesc:`Elves are a graceful and intelligent race, with an aptitude for both nature and magic, however they suffer from a frail constitution.
        \nAbility Scores: +2 Intelligence, +2 Dexterity, -2 Constitution
        \nDefenses: +2 bonus on saves vs enchantments, and immunity to sleep effects
        \nSkills: +6 perception, +4 knowledge nature, +2 spellcraft, knowledge arcana, escape artist, -4 craft, disable device
        \nSpecial: gain 1 spell point per level, and gain +2 bonus to overcome spell resistance. Gain 15 universal spell power and 1% universal spell critical chance.
        \nSize: Medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision
        \nBonus Rolls: Gain a spell, plus an additional spell every 5 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}));
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}));
            context.stats.characterStats.misc.spPerLevel += 1
            context.stats.characterStats.abilityScore.intelligence += 2
            context.stats.characterStats.abilityScore.dexterity += 1
            context.stats.characterStats.abilityScore.constitution -= 2
            context.stats.characterStats.skills.perception += 6
            context.stats.characterStats.skills.spellcraft += 2
            context.stats.characterStats.skills.knowArcana += 2
            context.stats.characterStats.skills.escapeArtist += 2
            context.stats.characterStats.skills.knowNature += 4
            context.stats.characterStats.skills.craft -= 4
            context.stats.characterStats.skills.disableDevice -= 4
            context.stats.characterStats.spellMastery.spellPower.universal += 15
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
        },
    },
    {
        rarity:"class",
        name:"Orc",
        longDesc:`Orcs are a ferocious beastial race, they are mostly made up of warriors, however they lack the higher thinking that many other races have.
        \nAbility Scores: +4 Strength, -2 Wisdom, Intelligence, Charisma 
        \nDefenses: Gain +2 to will saves while below 25% hit points, or against death effects and fear effects
        \nSkills: +6 intimidate, +2 climb, swim, -6 diplomacy, -2 bluff, sense motive, heal, stealth
        \nSpecial: When below 50% hit points you deal +1 damage with weapon attacks, if its a two-handed weapon this increases to +3. You also gain the ferocious ability: You remains conscious and can continue fighting even if your hit point total is below 0, you are still staggered and loses 1 hit point each round.
        \nSize: Medium
        \nSpeed: 30 feet
        \nVision: Darkvision
        \nBonus Rolls: At level 1 gain a C-E two-handed weapon roll, and a rage power every 8 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}));
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon", options:{weapon:{type:{twoHanded:true}, rarity:{common:true,rare:true,epic:true}}}}));
            context.stats.characterStats.abilityScore.strength += 4
            context.stats.characterStats.abilityScore.intelligence -= 2
            context.stats.characterStats.abilityScore.wisdom -= 2
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.intimidate += 6
            context.stats.characterStats.skills.climb += 4
            context.stats.characterStats.skills.swim += 4
            context.stats.characterStats.skills.diplomacy -= 6
            context.stats.characterStats.skills.bluff -= 2
            context.stats.characterStats.skills.senseMotive -= 2
            context.stats.characterStats.skills.heal -= 2
            context.stats.characterStats.skills.stealth -= 2
            
        },
    },
    {
        rarity:"class",
        name:"Ratfolk",
        longDesc:`Ratfolk are small rodent-like humanoids, they are renowned for their craftiness, abilities for fighting in packs, and ability to get into anything, but they are vicious and unliked by most other races, which is mutual.
        \nAbility Scores: +2 Dexterity, +1 Intelligence, -2 Strength, -2 Charisma
        \nDefenses: Gain a +4 bonus on saves against nausea, sickened, and disease. When a ratfolk shares a square with an ally larger than them, the ally can choose to take a -4 penalty to armor class to give the ratfolk a +2 bonus to their armor class and reflex saves. If the ally is unwilling, the ratfolk can reduce their allies armor class by -2 to gain a +1 bonus to their armor class and reflex saves.
        \nSkills: +4 craft, escape artist, perception, climb, swim, disable device, -6 diplomacy, perform, -4 heal, -2 knowledge planes, arcana, religion,
        \nSpecial: Ratfolk can share the square of an ally without either of them being considered squeezing. If two ratfolk share the same square and attack the same target in the same round, they are considered to be flanking that foe.
        \nSize: small (+1 size bonus to armor class and attack, -1 to CMB and CMD, +4 stealth, this also reduces the damage dice of all weapons by 1 size step)
        \nSpeed: 20 feet
        \nVision: Darkvision
        \nBonus Rolls: Teamwork feat every 8 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Teamwork Feat"}));
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.intelligence += 1
            context.stats.characterStats.abilityScore.strength -= 2
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.craft += 4
            context.stats.characterStats.skills.escapeArtist += 4
            context.stats.characterStats.skills.stealth += 4
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.climb += 2
            context.stats.characterStats.skills.swim += 2
            context.stats.characterStats.skills.disableDevice += 2
            context.stats.characterStats.skills.diplomacy -= 6
            context.stats.characterStats.skills.perform -= 6
            context.stats.characterStats.skills.heal -= 4
            context.stats.characterStats.skills.knowPlanes -= 2
            context.stats.characterStats.skills.knowReligion -= 2
            context.stats.characterStats.skills.knowArcana -= 2
            context.stats.statsForAbilities.ac.size += 1
            context.stats.statsForAbilities.bonusAtk += 1
            
        },
    },
    {
        rarity:"class",
        name:"Halfling",
        longDesc:`Halflings are small joyful race with natural incredible luck and a talent for stealth and diplomacy.
        \nAbility Scores: +2 Dexterity, +1 Charisma, -2 Strength
        \nDefenses: +1 bonus to all saves, and a +2 bonus on saves against fear
        \nSkills: +4 acrobatics, escape artist, +2 stealth, perform, disable device, climb, -4 intimidate, craft, -2 sense motive, survival,
        \nSpecial: Once per day you can reroll a dice that results in a natural 1 that you made. Once per day you can also reroll a failed save you made. Gain 1% universal spell critical chance and 10 positive spell power.
        \nSize: Small (+1 size bonus to armor class and attack, -1 to CMB and CMD, +4 stealth, this also reduces the damage dice of all weapons by 1 size step)
        \nSpeed: 20 feet
        \nVision: Normal
        \nBonus Rolls: C-E Universal Perk every 8 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"perk", options:{type:{universal:true},rarity:{common:true,rare:true,epic:true}}}));
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 1
            context.stats.characterStats.abilityScore.strength -= 2
            context.stats.characterStats.skills.acrobatics += 2
            context.stats.characterStats.skills.stealth += 6
            context.stats.characterStats.skills.perform += 2
            context.stats.characterStats.skills.climb += 2
            context.stats.characterStats.skills.disableDevice += 2
            context.stats.characterStats.skills.escapeArtist += 4
            context.stats.characterStats.skills.intimidate -= 4
            context.stats.characterStats.skills.craft -= 4
            context.stats.characterStats.skills.senseMotive -= 2
            context.stats.characterStats.skills.survival -= 2
            context.stats.characterStats.misc.will += 1
            context.stats.characterStats.misc.reflex += 1
            context.stats.characterStats.misc.fortitude += 1
            context.stats.statsForAbilities.ac.size += 1
            context.stats.statsForAbilities.bonusAtk += 1
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
            context.stats.characterStats.spellMastery.spellPower.positive += 10

        },
    },
    {
        rarity:"class",
        name:"Gnome",
        longDesc:`Gnomes are charismatic and adventurous creatures, with a remarkable durability for their size, with an aptitude for magic, especially illusion, though their nature leads them to make impulsive decisions. Gnomes are known for their passion for a specific subject, to the neglect of all others. 
        \nAbility Scores: +2 Charisma, +1 Constitution, -2 Strength, -1 Wisdom
        \nDefenses: gain a +2 bonus on saves against illusions, and +2 bonus to armor class against creatures huge or larger
        \nSkills: +4 craft, +2 disable device, -4 intimidate, -2 heal, knowledges, spellcraft, and a L skill roll
        \nSpecial: Increase the DC of all control spells you cast by +1. Gain 15 universal spell power and 1% universal spell critical chance.
        \nSize: Small (+1 size bonus to armor class and attack, -1 to CMB and CMD, +4 stealth, this also reduces the damage dice of all weapons by 1 size step)
        \nSpeed: 20 feet
        \nVision: Normal
        \nBonus Rolls: Gain a control spell at level 1, and every 5 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{control:true}}}));                
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true},rarity:{legendary:true}}}));
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{control:true}}}));
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.constitution += 1
            context.stats.characterStats.abilityScore.strength -= 2
            context.stats.characterStats.abilityScore.wisdom -= 1
            context.stats.characterStats.skills.craft += 4
            context.stats.characterStats.skills.disableDevice += 2
            context.stats.characterStats.skills.intimidate -= 4
            context.stats.characterStats.skills.heal -= 2
            context.stats.characterStats.skills.knowNature -= 2
            context.stats.characterStats.skills.knowArcana -= 2
            context.stats.characterStats.skills.knowReligion -= 2
            context.stats.characterStats.skills.knowPlanes -= 2
            context.stats.statsForAbilities.ac.size += 1
            context.stats.statsForAbilities.bonusAtk += 1
            context.stats.characterStats.spellMastery.spellPower.universal += 15
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
            

        },
    },
    {
        rarity:"class",
        name:"Aasimar",
        longDesc:`Aasimar are a race infused with divine blood, they are known for their extraordinary divine magic, and talent for smiting evil, and their lack of weaknesses.
        \nAbility Scores: E+ ability score roll
        \nDefenses: Gain acid, cold, and electricity resistance 5
        \nSkills: +6 heal, +4 knowledge religion, +2 diplomacy, intimidate
        \nSpecial: Gain a +1 insight bonus on attacks and damage against evil creatures, +2 if they are an evil outsiders. You gain 20 positive spell power, 4% positive spell critical chance, and 15% positive spell critical damage.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Darkvision
        \nBonus Rolls: At 1st and every 5 levels gain a healing spell, or a Radiant Dawn/Silver Crane maneuver.`,
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                self.getChoice(context,context.stats.characterStats.misc.level)          
            }
        },
        catchUpMethod:(context,self)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true},rarity:{epic:true,legendary:true,unique:true}}}));
            self.getChoice(context, 1)
            context.stats.characterStats.skills.heal += 6
            context.stats.characterStats.skills.knowReligion += 4
            context.stats.characterStats.skills.diplomacy += 2
            context.stats.characterStats.skills.intimidate += 2
            context.stats.characterStats.spellMastery.spellPower.positive += 20
            context.stats.characterStats.spellMastery.spellCriticalChance.positive += 4
            context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 15
        },
        getChoice: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }            
            let choices = []           
                 choices[0] = {
                    title:"Healing Spell",
                    id:0, 
                    method:(context=>{                            
                        options.type = {healing:true}
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options:options
                            }
                        ))
                    })}
                    choices[1] = {
                        title:"Maneuver",
                        id:1, 
                        method:(context=>{    
                            options.level.lvl0 = false
                            options.school = {radiantDawn:true, silverCrane:true}
                            context.connection.send(JSON.stringify(
                                {
                                    command:"requestRoll", 
                                    type:"maneuver", 
                                    options
                                }
                            ))
                        })
                    }
            let custom = {title:"Aasimar Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity:"class",
        name:"Tiefling",
        longDesc:`Tieflings are a race infused with infernal blood, they are known for their destructive and deceptive powers.
        \nAbility Scores: E+ ability score roll, -2 charisma
        \nDefenses: Gain cold, electricity, and fire resistance 5
        \nSkills: +4 intimidate, +4 bluff, +2 stealth, knowledge planes, -2 heal, -4 diplomacy
        \nSpecial: Gain 15 universal spell power, 1% universal spell critical chance, but -40 positive spell power and -4% positive spell critical chance. You gain a primary bite attack that deals 1d4 damage.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Darkvision
        \nBonus Rolls: At 1st and every 5 levels gain a damage spell, or a black seraph/veiled moon maneuver.`,
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                self.getChoice(context, context.stats.characterStats.misc.level)          
            }
        },
        catchUpMethod:(context,self)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true},rarity:{epic:true,legendary:true,unique:true}}}));
            self.getChoice(context, 1)
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.bluff += 4
            context.stats.characterStats.skills.stealth += 2
            context.stats.characterStats.skills.knowPlanes += 2
            context.stats.characterStats.skills.intimidate += 4
            context.stats.characterStats.skills.diplomacy -= 4
            context.stats.characterStats.skills.heal -= 2
            context.stats.characterStats.spellMastery.spellPower.universal += 15
            context.stats.characterStats.spellMastery.spellPower.positive -= 40
            context.stats.characterStats.spellMastery.spellCriticalChance.positive -= 4
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
        },
        getChoice: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }            
            let choices = []           
                 choices[0] = {
                    title:"Damage Spell",
                    id:0, 
                    method:(context=>{                            
                        options.type = {damage:true}
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options:options
                            }
                        ))
                    })}
                    choices[1] = {
                        title:"Maneuver",
                        id:1, 
                        method:(context=>{    
                            options.level.lvl0 = false
                            options.school = {blackSeraph:true, veiledMoon:true}
                            context.connection.send(JSON.stringify(
                                {
                                    command:"requestRoll", 
                                    type:"maneuver", 
                                    options
                                }
                            ))
                        })
                    }
            let custom = {title:"Tiefling Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity:"class",
        name:"Fetchling",
        longDesc:`Fetchlings are a race who have been infused with the shadow plane, they are stealthy and their eyes pierce darkness unlike any other, but also remarkably charismatic
        \nAbility Scores: +2 Dexterity, +2 Charisma, -2 Wisdom
        \nDefenses: Gain cold and electricity resistance 5
        \nSkills: +6 stealth, +2 diplomacy, bluff, intimidate
        \nSpecial: If a map has low-light conditions you gain +1 dodge bonus to armor class, if its dark conditions you gain +2 instead. If you are in a magical effect that creates low-light or darkness, the bonus doubles, even if the attacking creatures can see you normally. In magical darkness you gain a +6 dodge bonus to armor class. On maps with normal lighting you take a -1 penalty to attack and armor class, and a -3 penalty to attack and armor class in bright light.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Darkvision 120ft, Low-light vision, they can see through magical darkness as if it was low-light instead (with normal vision).
        \nBonus Rolls: Gain a rogue perk every 8 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"}));                
            }            
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.wisdom -= 2
            context.stats.characterStats.skills.stealth += 6
            context.stats.characterStats.skills.bluff += 2
            context.stats.characterStats.skills.intimidate += 2
            context.stats.characterStats.skills.diplomacy += 2            
            if(context.stats.characterStats.misc.class == "Wizard"){
                let perk = {rarity:"class", name:"Possible Initiate", id:Math.random()*1000000, type:"magic", shortDesc:`You're a possible initiate of a very powerful clan of wizards, wonder who they could be...`}
                context.stats.lists.perks.push(perk)
            }
        },        
    },
    {
        rarity:"class",
        name:"Drow",
        longDesc:`Drow are a race of deep underground elves, they are known for their variety of talents and resistances, from assassination, to magic, to their resistance to magic, and charisma. They however also suffer from a frail constitution like all elves.
        \nAbility Scores: +2 Dexterity, +2 Charisma -2 constitution
        \nDefenses: Gain a +1 bonus on saving throws against spells, immunity to sleep
        \nSkills: +6 stealth, +4 disable device, bluff, +2 perception, knowledge arcana, 
        \nSpecial: gain 1 spell point per level, and gain the spell levitate. Gain 20% spell critical damage.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Darkvision 120ft, Low-light vision
        \nBonus Rolls: Gain a utility/buff spell at 1st and every 5 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{utility:true,buff:true}}}))
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{utility:true,buff:true}}}))
            context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Levitate")[0])
            context.stats.characterStats.misc.spPerLevel += 1
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.constitution -= 2
            context.stats.characterStats.skills.stealth += 6
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.knowArcana += 2
            context.stats.characterStats.skills.disableDevice += 4
            context.stats.characterStats.skills.bluff += 4
            context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 20
            if(context.stats.characterStats.misc.class == "Wizard"){
                    let perk = {rarity:"class", name:"Possible Initiate", id:Math.random()*1000000, type:"magic", shortDesc:`You're a possible initiate of a very powerful clan of wizards, wonder who they could be...`}
                    context.stats.lists.perks.push(perk)
            }            
        },
    },
    {
        rarity:"class",
        name:"Sylph",
        longDesc:`Sylphs are a race infused by the elemental plane of air, they are quick and intelligent, but fragile
        \nAbility Scores: +2 Dexterity, +2 intelligence -2 Constitution
        \nDefenses: Gain electricity resistance 10, and a +2 dodge bonus to armor class when in light, or no armor, and a +1 dodge bonus when in medium armor.
        \nSkills: +6 fly, +4 acrobatics, perform, -4 swim, climb, -2 intimidate
        \nSpecial: Increase the DC of air and electricity spells by +1, 15 air spell power, and 4% air spell critical chance. When in medium or lighter armor they gain 5 extra feet of movement, increasing by another 5 every 5 levels. They gain an additional +2 to acrobatics for checks made to jump.
        \nSize: medium
        \nSpeed: 30 feet (35 feet)
        \nVision: Sylphs see 50% further in foggy conditions, and can see twice as far in fog spells,
        \nBonus Rolls: gain a utility spell or a Heart of the Maelstrom/Elemental Flux/Tempest Gale maneuver, and another every 5 levels`,
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                self.getChoice(context, context.stats.characterStats.misc.level)
            }
        },
        catchUpMethod:(context,self)=>{
            self.getChoice(context, 1)
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.intelligence += 2
            context.stats.characterStats.abilityScore.constitution -= 2
            context.stats.characterStats.skills.acrobatics += 4
            context.stats.characterStats.skills.fly += 6
            context.stats.characterStats.skills.perform += 2
            context.stats.characterStats.skills.swim -= 4
            context.stats.characterStats.skills.climb -= 4
            context.stats.characterStats.skills.intimidate -= 2            
            context.stats.characterStats.spellMastery.spellPower.air += 15
            context.stats.characterStats.spellMastery.spellCriticalChance.air += 4
        },
        getChoice: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }            
            let choices = []           
                 choices[0] = {
                    title:"Utility Spell",
                    id:0, 
                    method:(context=>{                            
                        options.type = {utility:true}
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options:options
                            }
                        ))
                    })}
                    choices[1] = {
                        title:"Maneuver",
                        id:1, 
                        method:(context=>{    
                            options.level.lvl0 = false
                            options.school = {heartOfTheMaelstrom:true, elementalFlux:true,tempestGale:true}
                            context.connection.send(JSON.stringify(
                                {
                                    command:"requestRoll", 
                                    type:"maneuver", 
                                    options
                                }
                            ))
                        })
                    }
            let custom = {title:"Sylph Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity:"class",
        name:"Undine",
        longDesc:`Undine are a race infused by the elemental plane of water, they are wise and patient, and slow to violence
        \nAbility Scores: +2 Wisdom, +2 Dexterity, -2 Strength
        \nDefenses: Gain cold resistance 10, 
        \nSkills: +4 swim, escape artist, heal, +2 sense motive, -8 climb, -4 fly, -2 disable device
        \nSpecial: Increase the DC of cold and water spells by +1, 15 cold spell power, and 2% cold spell critical chance. When fully submerged in water they gain fast healing 1/2 con mod, or for 1 round when they take cold damage that penetrates their resistance.
        \nSize: medium
        \nSpeed: 30 feet, 30 foot swim
        \nVision: Low-light,
        \nBonus Rolls: At level 1 and every 5 levels you can choose between a healing spell, or a Mithral Current/Elemental Flux maneuver`,
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                self.getChoice(context, context.stats.characterStats.misc.level)
            }
        },
        catchUpMethod:(context,self)=>{
            self.getChoice(context, 1)
            context.stats.characterStats.abilityScore.wisdom += 2
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.strength -= 2
            context.stats.characterStats.skills.swim += 4
            context.stats.characterStats.skills.heal += 4
            context.stats.characterStats.skills.senseMotive += 2
            context.stats.characterStats.skills.escapeArtist += 4
            context.stats.characterStats.skills.climb -= 8
            context.stats.characterStats.skills.fly -= 4
            context.stats.characterStats.skills.disableDevice -= 2            
            context.stats.characterStats.spellMastery.spellPower.cold += 15
            context.stats.characterStats.spellMastery.spellCriticalChance.cold += 2
        },
        getChoice: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, }
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }            
            let choices = []           
                 choices[0] = {
                    title:"Healing Spell",
                    id:0, 
                    method:(context=>{                            
                        options.type = {healing: true}
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options:options
                            }
                        ))
                    })}
                    choices[1] = {
                        title:"Maneuver",
                        id:1, 
                        method:(context=>{    
                            options.level.lvl0 = false
                            options.school = {mithralCurrent:true,elementalFlux:true}
                            context.connection.send(JSON.stringify(
                                {
                                    command:"requestRoll", 
                                    type:"maneuver", 
                                    options
                                }
                            ))
                        })
                    }
            let custom = {title:"Undine Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity:"class",
        name:"Ifrit",
        longDesc:`Ifrit are a race infused by the elemental plane of fire, they fiery and passionate
        \nAbility Scores: +2 Dexterity, +2 Charisma, -2 Wisdom
        \nDefenses: Gain fire resistance 10, 
        \nSkills: +4 intimidate, +4 diplomacy, -8 swim -4 stealth, 
        \nSpecial: Increase the DC of fire spells by +1 and gain 20 fire spell power and 10% fire spell critical damage. You gain a +2 bonus to initiative checks. When a creature damages you with a natural weapon it takes 1 point of fire damage. This increases by 1 point every 4 levels. This stacks with other similar abilities, but it added to the damage and not as a seperate damage source.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Smokesight: You can see through natural and magical smoke (not fog), as well as fog you create through magical means.
        \nBonus Rolls: At level 1 and every 5 levels you can choose between a damage spell, or a Burning Citadel/Elemental Flux/Solar Wind maneuver`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                self.getChoice(context, context.stats.characterStats.misc.level)
            }
        },
        catchUpMethod:(context, self)=>{
            self.getChoice(context,1)
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.wisdom -= 2
            context.stats.characterStats.skills.intimidate += 4
            context.stats.characterStats.skills.diplomacy += 4
            context.stats.characterStats.skills.swim -= 8
            context.stats.characterStats.skills.stealth -= 4
            context.stats.characterStats.spellMastery.spellPower.fire += 20
            context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 10
        },
        getChoice: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, }
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }            
            let choices = []           
                 choices[0] = {
                    title:"Damage Spell",
                    id:0, 
                    method:(context=>{                            
                        options.type = {damage: true}
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options:options
                            }
                        ))
                    })}
                    choices[1] = {
                        title:"Maneuver",
                        id:1, 
                        method:(context=>{    
                            options.level.lvl0 = false
                            options.school = {burningCitadel:true,elementalFlux:true,solarWind:true,}
                            context.connection.send(JSON.stringify(
                                {
                                    command:"requestRoll", 
                                    type:"maneuver", 
                                    options
                                }
                            ))
                        })
                    }
            let custom = {title:"Ifrit Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity:"class",
        name:"Oread",
        longDesc:`Oread are a race infused by the elemental plane of earth, they are legendary for their durability and resistances, but also strong, but are as charismatic as a brick wall.
        \nAbility Scores: +2 Strength, +1 Wisdom, -2 Charisma
        \nDefenses: Gain acid resistance 10, DR 1/adamantine (becomes DR 5/adamantine against constrict damage), this stacks with other DR, +2 CMD, +1 natural armor bonus, and a +4 armor class bonus against ray spells,
        \nSkills: +8 climb, +4 survival, +2 sense motive, -6 acrobatics, swim, fly
        \nSpecial: Increase the DC of earth/acid spells by +1 and gain 15 acid spell power. Rocks you throw have their damage step increased by 1 for every level/2. 
        \nSize: medium
        \nSpeed: 20 feet
        \nVision: Darkvision
        \nBonus Rolls: Gain a ring/neck wonderous item every 7 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %7 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"wonderousItems", options:{type:{neck:true,ring:true}}})); 
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.strength += 2
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.climb += 8
            context.stats.characterStats.skills.survival += 4
            context.stats.characterStats.skills.senseMotive += 2
            context.stats.characterStats.skills.acrobatics -= 6
            context.stats.characterStats.skills.swim -= 6
            context.stats.characterStats.skills.fly -= 6
            context.stats.statsForAbilities.ac.natural += 1
            context.stats.characterStats.spellMastery.spellPower.acid += 15
        },
    },
    {
        rarity:"class",
        name:"Suli",
        longDesc:`Suli are a race infused by the all elements that they can unleash to devastate foes, while also having resistance to those elements themselves.
        \nAbility Scores: +2 Strength, +2 Charisma, -2 Intelligence
        \nDefenses: Gain acid, cold, fire, and electricity resistance 5
        \nSkills: +4 diplomacy, sense motive, +2 perform, knowledge planes, -4 stealth, -2 knowledge nature, bluff, heal, survival
        \nSpecial: Once per day as a free action you can sheathe your body in elemental energy, your melee attacks for the rest of the round deal 1d6 elemental damage of an element of your choice, and when you are damaged with a non-reach melee weapon they take 1d6 damage of that element. Every 4 levels this damage increases by 1d6. Gain 5 elemental spell power.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision, Darkvision
        \nBonus Rolls: Gain a r-e weapon enchantment every 6 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment", options:{weaponEnchantments:{rarity:{rare:true,epic:true}}}}))
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellPower.fire += 5
            context.stats.characterStats.spellMastery.spellPower.cold += 5
            context.stats.characterStats.spellMastery.spellPower.acid += 5
            context.stats.characterStats.spellMastery.spellPower.electricity += 5
            context.stats.characterStats.abilityScore.strength += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.intelligence -= 2
            context.stats.characterStats.skills.diplomacy += 4
            context.stats.characterStats.skills.senseMotive += 4
            context.stats.characterStats.skills.perform += 2
            context.stats.characterStats.skills.knowPlanes -= 2
            context.stats.characterStats.skills.stealth -= 4
            context.stats.characterStats.skills.knowNature -= 2
            context.stats.characterStats.skills.bluff -= 2
            context.stats.characterStats.skills.heal -= 2
            context.stats.characterStats.skills.survival -= 2
        },
    },
    {
        rarity:"class",
        name:"Shabti",
        longDesc:`Shabti are a race of fabricated souls bound to a fabricated bodies, they are ageless, durable, with a strong force of will.
        \nAbility Scores: +2 Constitution, +2 Charisma
        \nDefenses: A shabti takes no penalties from energy drain, though still dies if it has as many negative levels as levels. At the end of the floor all temporary negative levels are removed without need for a save. Shabti also gain a +2 bonus on saves against death effects, negative energy, or fear, and is immune to age effects. A shabti adds its level to how many negative hit points it can have before it dies.
        \nSkills: +2 to all knowledges, -2 heal, survival, sense motive, a c-r Skill roll
        \nSpecial: A shabti is difficult to revive, to bring a Shabti back from the dead the caster must make a caster level check DC 10+Shabti's HD.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Normal
        \nBonus Rolls: Gain a Skill roll every 4 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}})); 
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true},rarity:{common:true,rare:true}}})); 
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.skills.knowArcana += 2
            context.stats.characterStats.skills.knowPlanes += 2
            context.stats.characterStats.skills.knowNature += 2
            context.stats.characterStats.skills.knowReligion += 2
            context.stats.characterStats.skills.heal -= 2
            context.stats.characterStats.skills.survival -= 2
            context.stats.characterStats.skills.senseMotive -= 2
            
        },
    },
    {
        rarity:"class",
        name:"Half Giant",
        longDesc:`Half Giant's are a race of powerfully built creatures who can wield slightly larger weapons than any other medium creatures, and are renown for their strong believe in liberty or death.
        \nAbility Scores: +2 Strength, +1 Wisdom, -3 Dexterity, -1 Intelligence, -1 Charisma
        \nDefenses: You count as one size larger for CMB and CMD checks if it would benefit you, and gain +2 racial bonus on saving throws against mind-affecting effects.
        \nSkills: +4 climb, swim, -4 acrobatics, escape artist, stealth, disable device,
        \nSpecial: Increase the damage of all weapons you wield by 1 dice step. Increase your base spell points by 3.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: normal
        \nBonus Rolls: Gain an Ability Score roll every 6 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}})); 
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.strength += 2
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.dexterity -= 3
            context.stats.characterStats.abilityScore.charisma -= 1
            context.stats.characterStats.abilityScore.intelligence -= 1
            context.stats.characterStats.spellpointIncreases.push(3)
            context.stats.characterStats.skills.climb += 4
            context.stats.characterStats.skills.swim += 4
            context.stats.characterStats.skills.acrobatics -= 4
            context.stats.characterStats.skills.escapeArtist -= 4
            context.stats.characterStats.skills.stealth -= 4
            context.stats.characterStats.skills.disableDevice -= 4
        },
    },
    {
        rarity:"class",
        name:"Dhampir",
        longDesc:`Dhampirs are half vampires, living on the edge of alive and dead, and as such, carry with them many of a vampires strengths and weaknesses.
        \nAbility Scores: +2 Dexterity, +2 Charisma, -2 Constitution
        \nDefenses: A Dhampir takes no penalties from energy drain, though still dies if it has as many negative levels as levels. At the end of the floor all temporary negative levels are removed without need for a save. Dhampir's also gain a +2 bonus on saves against death effects, diseases, and poison.
        \nSkills: +6 diplomacy, +4 bluff, stealth, +2 perception, -4 heal, Knowledge Nature, knowledge Religion, Survival
        \nSpecial: You only heal 50% from positive energy, but now instead of taking damage from negative energy you heal 50%. You gain a secondary bite attack that deals 1d3 damage, and once per round when you damage a creature with it that has blood, you heal hit points equal to half the damage dealt. Additionally, you count as undead for spells and abilities that would provide beneficial effects to undead used by yourself or allies, such as grave call from unquiet grave or repair undead. You gain 20 negative energy spell power, and 2% negative energy spell critical chance, but lose 30 positive spell power and 3% positive spell critical chance.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision, Darkvision,
        \nBonus Rolls: Gain a rogue perk every 8 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"})); 
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.constitution -= 2
            context.stats.characterStats.skills.bluff += 4
            context.stats.characterStats.skills.stealth += 4
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.diplomacy += 2
            context.stats.characterStats.skills.heal -= 4
            context.stats.characterStats.skills.knowNature -= 4
            context.stats.characterStats.skills.knowReligion -= 4
            context.stats.characterStats.skills.survival -= 4
            context.stats.characterStats.spellMastery.spellPower.negative += 20
            context.stats.characterStats.spellMastery.spellCriticalChance.negative += 2
            context.stats.characterStats.spellMastery.spellPower.positive -= 30
            context.stats.characterStats.spellMastery.spellCriticalChance.positive -= 3
        },
    },
    {
        rarity:"class",
        name:"Strix",
        longDesc:`Strix are dark skinned humanoids that appear similar to a winged devil, they are famous for their skill with ranged weapons, and their hatred for other humanoids.
        \nAbility Scores: +2 Dexterity, +1 Charisma, -2 Constitution
        \nDefenses: Strix gain +2 bonus against illusion spells and effects.
        \nSkills: +6 fly, +2 perception, stealth, bluff, -4 climb, swim, -2 diplomacy, intimidate
        \nSpecial: You gain a +1 bonus to attack with ranged weapons, +1 damage with bows, and a +1 to attack and damage against humanoids.
        \nSize: medium
        \nSpeed: 30 feet, 30 foot fly (average)
        \nVision: Low-light Vision
        \nBonus Rolls: At level 1 you gain a C-E primitive/tech weapon`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.doesNothing = {}
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon",options:{weapon:{type:{primitive:true,tech:true}, rarity:{common:true, rare:true,epic:true}}}}))
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 1
            context.stats.characterStats.abilityScore.constitution -= 2
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.stealth += 2
            context.stats.characterStats.skills.bluff += 2
            context.stats.characterStats.skills.fly += 6
            context.stats.characterStats.skills.climb -= 4
            context.stats.characterStats.skills.swim -= 4
            context.stats.characterStats.skills.diplomacy -= 2
            context.stats.characterStats.skills.intimidate -= 2
        },
    },
    {
        rarity:"class",
        name:"Merfolk",
        longDesc:`Merfolk half the top half of a human, and the bottom half of a fish. They are strong and charismatic, but suffer from difficulty moving on land.
        \nAbility Scores: +2 Constitution, +2 Charisma, +1 Dexterity
        \nDefenses: Gain a +2 racial bonus to natural armor, and since a merfolk does not have legs, they are immune to trip.
        \nSkills: +6 perform, +4 swim, +2 survival, -12 climb, -8 acrobatics, -4 fly,
        \nSpecial: Merfolk can breathe in water and gain a +1 to the DC's of language dependant and sonic spells they cast.
        \nSize: medium
        \nSpeed: 15 feet, 40 foot swim speed
        \nVision: Low-light Vision
        \nBonus Rolls: Gain a utility feat every 8 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"feats",options:{type:{utility:true}}})); 
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 1
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.skills.perform += 6
            context.stats.characterStats.skills.swim += 4
            context.stats.characterStats.skills.survival += 2
            context.stats.characterStats.skills.climb -= 12
            context.stats.characterStats.skills.fly -= 4
            context.stats.characterStats.skills.acrobatics -= 8
            context.stats.statsForAbilities.ac.natural += 2

        },
    },
    {
        rarity:"class",
        name:"Samsaran",
        longDesc:`Mysterious humanoids with pale blue flesh and transparent blood like the waters of a trickling brook, samsarans are ancient creatures that reincarnates every time it dies, and carries with it much knowledge.
        \nAbility Scores: +2 Intelligence, +1 Wisdom, -1 Constitution
        \nDefenses: Gain +1 fortitude save. Additionally gain +1 to saves against negative energy, death effects, and +2 to remove negative levels and stabilize while dying
        \nSkills: 2 R-E skill rolls
        \nSpecial: Gain 3 level 1-2 spells, and 10 universal spell power.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: normal
        \nBonus Rolls: C-E magic perk every 8 levels, and a spell every 6`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
            }
            if(context.stats.characterStats.misc.level %8 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk",options:{type:{magic:true},rarity:{common:true,rare:true,epic:true,}}})); 
            }
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats",options:{type:{skills:true},rarity:{rare:true,epic:true}}}))
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats",options:{type:{skills:true},rarity:{rare:true,epic:true}}})) 
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
            context.stats.characterStats.abilityScore.intelligence += 2
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.constitution -= 1
            context.stats.characterStats.spellMastery.spellPower.universal += 10

        },
    },
    {
        rarity:"class",
        name:"Goblin",
        longDesc:`Goblins are awful little creatures each with a different nature for different kinds of awful things, but their tiny stature makes them quite fragile and weak, which they mostly make up for with their dexterity.
        \nAbility Scores: +4 Dexterity, -2 Strength, -2 Charisma
        \nDefenses: Gain a +4 bonus on saves against nausea, sickened, disease, and +2 reflex save, but a -2 penalty on will saves against fear.
        \nSkills: +4 stealth, acrobatics, escape artist, +2 disable device, -2 to knowledges, survival, and diplomacy
        \nSpecial: Pick a special goblin nature. Additionally, goblins gain a +10 bonus when selecting greed for party drops (instead of -15)
        \nSize: small (+1 size bonus to armor class and attack, -1 to CMB and CMD, +4 stealth, this also reduces the damage dice of all its weapon and natural attacks by 1 size step)
        \nSpeed: 30 feet, 10 feet climb
        \nVision: Darkvision
        \nBonus Rolls: You gain 25 gold, and a C wonderous item at level 1 and every 4 levels (he didn't steal it, he swears)`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"wonderousItems", options:{rarity:{common:true}}})); 
            }            
        },        
        catchUpMethod:(context, self)=>{
            context.stats.gold += 25
            context.connection.send(JSON.stringify({command:"requestRoll", type:"wonderousItems", options:{rarity:{common:true}}})); 
            context.stats.characterStats.abilityScore.dexterity += 4
            context.stats.characterStats.abilityScore.strength -= 2
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.stealth += 8
            context.stats.characterStats.skills.acrobatics += 4
            context.stats.characterStats.skills.escapeArtist += 4
            context.stats.characterStats.skills.disableDevice += 2
            context.stats.characterStats.skills.knowArcana -= 2
            context.stats.characterStats.skills.knowPlanes -= 2
            context.stats.characterStats.skills.knowNature -= 2
            context.stats.characterStats.skills.knowReligion -= 2
            context.stats.characterStats.skills.survival -= 2
            context.stats.characterStats.skills.diplomacy -= 2
            context.stats.characterStats.misc.reflex += 2
            context.stats.statsForAbilities.ac.size += 1
            context.stats.statsForAbilities.bonusAtk += 1
            self.getChoice(context,self)
        },
        getChoice: (context,self)=>{
            let natures = self.natures            
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*natures.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*natures.length)
                chosen.push(possible)
                let option = natures[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Goblin")[0]
                        perk.longDesc += "\n\nNature: \n\n" + option.name + ": " + option.description + "\n\n"
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                        }
                    })
                }
                
            }
            let custom = {title:"Goblin Nature", options:choices}
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            return self.natures
        },
        natures:[
            {
                name:"Stupid",
                description:`No thoughts, head empty. On the bright side your skull makes for a great shield in an emergency. You have -4 intelligence and +1 natural armor. You can take 1d4 points of intelligence damage as an immediate action to reduce a critical hit or sneak attack against you to instead roll the damage normally.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.intelligence -= 4
                    context.stats.statsForAbilities.ac.natural += 1
                }
            },
            {
                name:"Annoying",
                description:`You are unbelievably annoying, constantly causing an unbearable racket everywhere you go. You receive a -2 charisma and -8 to stealth. As a swift action you can make a diplomacy check with a +10 bonus against a creatures will save, if it fails, it gains a +2 bonus to its attack and armor class against you, for all other creatures it takes -2 penalty to attacks and Armor class for 1. For each 5 you beat their save by these penalties and bonuses increase by 1 and the duration increases by 1 round. This is a mind-affecting effect.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma -= 2
                    context.stats.characterStats.skills.stealth -= 8
                }
            },
            {
                name:"Foolish",
                description:`You really dont know when something is a bad idea. You gain -2 wisdom, but +2 on saves against fear, and you gain a +2 dodge bonus against attacks of opportunity. When a creature takes an attack of opportunity against you, you get a +2 bonus on your next attack roll against them, this stacks.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.wisdom -= 2
                }
            },
            {
                name:"Insane",
                description:`You are completely unhinged. You receive -4 wisdom, and the first round of combat you are confused, however you are immune to compulsion effects. Gain 4% universal spell critical chance and 25% universal spell critical damage. Whenever you roll a critical damage spell, you suffer 10% of the spells damage (no save).`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.wisdom -= 4
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 4
                    context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 25
                }
            },
            {
                name:"Cowardly",
                description:`You are a complete coward. You take a -2 penalty to will saves, with an additional -2 penalty on will saves against fear. When you attacking a creature you flank or is denied its dexterity bonus to armor class, or attacking a creature at least 30 feet away from you, you gain a +2 to the attack roll as long as it hasn't damaged you in 1 round. This stacks if multiple apply.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.misc.will -= 2
                }
            },
            {
                name:"Disgusting",
                description:`You are a disgusting little filth carrier, your charisma is reduced by -4, but you gain a +2 bonus on fortitude saves, and a further +2 bonus on saves vs sickened, nausea, and disease, and you gain the stench special ability, which lasts 10 rounds.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma -= 4
                    context.stats.characterStats.misc.fortitude += 2
                }
            },
            {
                name:"Fat",
                description:`You are a gluttonous little green ball with a talent for rolling. You receive -2 dexterity, a -4 penalty to acrobatics and stealth, but you gain +2 constitution and can move at half speed while prone.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity -= 2
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.acrobatics -= 4
                    context.stats.characterStats.skills.stealth -= 4
                }
            },
            {
                name:"Evil",
                description:`You are smart enough to understand evil and actually pursue it. You gain +2 intelligence but take a -2 penalty to dexterity. You gain a +2 bonus to attack and damage against good creatures, +3 if they are good outsiders. Gain 10 universal spell power and 1% universal spell critical chance.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.intelligence += 2
                    context.stats.characterStats.abilityScore.dexterity -= 2
                    context.stats.characterStats.spellMastery.spellPower.universal += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                }
            },
            {
                name:"Treacherous",
                description:`You are a treacherous little monster. When an attack confirms against you, you may use an immediate action to cause an adjacent ally to take the damage from the attack instead of you. This ability only works against an individual monster once. You reduce the numeric bonuses teamwork feats give you by -1.`,                                
            },
            {
                name:"Greedy",
                description:`You just never can have enough, so much so that parting with your gold for intangible things physically hurts you. Gain 50 additional gold. When you buy perks, feats, stats, spells, or maneuvers, you take damage equal to your HD per 25 gold spent. For each 100 gold you are carrying you gain a +1 morale bonus on saving throws.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.gold += 50
                }
            },
            {
                name:"Cruel",
                description:`You just love killing and making things suffer. When making multiple attacks at once, if one of your attacks reduces a creature below 0, you must use your remaining attacks on them. When you kill an enemy you gain a +1 morale bonus on attacks, damage, and saves for 1d4 rounds, this stacks.`,                
            },
            {
                name:"Destructive",
                description:`You are a destructive little monster. When you use grenade gear its DC increases by +2, and deals an extra 2d6 damage. You start the game with 1d4+1 alchemist's fire. Gain 15 fire spell power, 2% fire spell critical chance, and 15% fire spell critical damage.`,                
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.fire += 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire += 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 15
                }
            },
            {
                name:"Redeemed",
                description:`You've risen above a goblins nature and work hard to protect others and prove yourself. When an adjacent ally has an attack confirmed against them, you can use an immediate action to reduce the damage they took by 50%, you take this damage in their place.`,                
            },
        ],        
    },
    {
        rarity:"class",
        name:"Lizardfolk",
        longDesc:`These giant humanoid lizards have powerful claws and teeth, and are protected by a thick scaly hide.
        \nAbility Scores: +2 Strength, +2 Constitution, -2 Intelligence, -2 Charisma
        \nDefenses: Gain a +2 racial bonus to natural armor
        \nSkills: +8 swim, +4 intimidate, +2 survival, -4 acrobatics, fly, heal, diplomacy
        \nSpecial: Lizardfolk gain a bite attack that deals 1d6 damage, and two claw attacks that each deal 1d4 damage. These are all primary natural attacks.
        \nSize: medium
        \nSpeed: 30 feet, swim speed 20 ft
        \nVision: normal
        \nBonus Rolls: Gain a strike at level 1, and every 5 levels after`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Strike:true}}})); 
            }            
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Strike:true}}})); 
            context.stats.characterStats.abilityScore.strength += 2
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.abilityScore.intelligence -= 2
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.swim += 8
            context.stats.characterStats.skills.intimidate += 4
            context.stats.characterStats.skills.survival += 2
            context.stats.characterStats.skills.acrobatics -= 4
            context.stats.characterStats.skills.fly -= 4
            context.stats.characterStats.skills.heal -= 4
            context.stats.characterStats.skills.diplomacy -= 4
            context.stats.statsForAbilities.ac.natural += 2
            if(context.stats.characterStats.misc.class == "Wizard"){
                let perk = {rarity:"class", name:"Wizard Lizard", id:Math.random()*1000000, type:"magic", shortDesc:`You're a wizard lizard, what an odd choice of character. You do gain +0.5 spell points per level though, which is cool.`}
                context.stats.lists.perks.push(perk)
                context.stats.characterStats.misc.spPerLevel += 0.5
            }
        },
    },
    {
        rarity:"class",
        name:"Hobgoblin",
        longDesc:`These creatures look just like a larger goblin, but they couldn't be more different. Hobgoblins are noble and warrior race that takes great pride in their fighting techniques, though still cruel and tyrannical, and extraordinarily hostile.
        \nAbility Scores: +2 Dexterity, +2 Constitution, -2 Charisma
        \nDefenses: They gain a +1 on fortitude saves and a +1 racial bonus to natural armor
        \nSkills: +4 stealth, +6 intimidate, -6 diplomacy, -4 bluff
        \nSpecial: Hobgoblins deal +2 damage on strikes, and once per day as a free action they can act as if they are in two stances for 1 round, choosing a stance they weren't in, and adding it to the stance they currently are.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Darkvision
        \nBonus Rolls: Stance at level one, and a maneuver every 5 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver"}))
            }            
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Stance:true}}}))
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.stealth += 4
            context.stats.characterStats.skills.intimidate += 6
            context.stats.characterStats.skills.diplomacy -= 6
            context.stats.characterStats.skills.bluff -= 4
            context.stats.characterStats.misc.fortitude += 1
            context.stats.statsForAbilities.ac.natural += 1
        },
    },
    {
        rarity:"class",
        name:"Deep One Hybrid",
        longDesc:`These creatues creatures are have large bulbous eyes and enongated heads, as well as fishlike scales and webbed hands. They almost pass as a deformed human, though not for long, when they take their final transformation into a full deep one.
        \nAbility Scores: +2 Constitution, +2 Wisdom, -2 Dexterity, -1 Charisma
        \nDefenses: +1 natural armor
        \nSkills: +4 swim, bluff, +2 survival, knowledge religion, -4 disable device, climb, perform,
        \nSpecial: When entering a new floor (except the first), you can choose to make your final change. When you do, you gain a bonus to your strength score equal to the floors completed *2, and half as much to constitution, but your dexterity is reduced by floors completed *2 (this can bring the score to 0). When you do, you also gain low-light vision, dark vision, and your natural armor bonus increases to +2. This change is permanent. At the start of each floor (except first) until you have undergone your final change, you take drain to your wisdom equal to the floor number you are entering. This doesn't happen on maps that are underwater, or maps near the sea.
        \nSize: medium
        \nSpeed: 20 feet, 30 ft swim speed.
        \nVision: normal
        \nBonus Rolls: none`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.doesNothing = "does nothing"
            // if(context.stats.characterStats.misc.level %5 == 0){
            //     context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Strike:true}}})); 
            // }            
        },
        catchUpMethod:(context)=>{
            //context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Stance:true}}}))
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.abilityScore.wisdom += 2
            context.stats.characterStats.abilityScore.dexterity -= 2
            context.stats.characterStats.abilityScore.charisma -= 1
            context.stats.characterStats.skills.swim += 4
            context.stats.characterStats.skills.bluff += 4
            context.stats.characterStats.skills.survival += 4
            context.stats.characterStats.skills.knowReligion += 2
            context.stats.characterStats.skills.disableDevice -= 4
            context.stats.characterStats.skills.climb -= 4
            context.stats.characterStats.skills.perform -= 4
            context.stats.statsForAbilities.ac.natural += 1
        },
    },
    {
        rarity:"class",        
        name:"Mutant",
        longDesc:`Its hard to tell what this thing originally was, now it is a strange patch-work of horrific features mutated beyond recognition in a vaguely humanoid shape, but it seems to at least be able to communicate (sometimes anyway).
        \nAbility Scores: +2 Strength, +2 Dexterity, +2 Constitution, -4 Intelligence, -2 Wisdom, -4 Charisma
        \nDefenses: +1 fortitude and reflex, a +2 racial bonus to natural armor, and a -4 penalty to will saves, except against fear, which it instead gets +2.
        \nSkills: +6 intimidate, +2 climb, swim, -12 diplomacy, -8 heal, E Skill
        \nSpecial: Gain a deformity, and a mutation.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: normal
        \nBonus Rolls: Every level you have a chance to gain an additional mutation or deformity`,
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            let odds = 0.7
            let perk = context.stats.lists.perks.filter(perk => perk.name == "Mutant")[0]
            if(perk.longDesc.includes("Unstable Form")) odds -= 0.3
            if(Math.random() > odds){
                if(Math.random() > 0.70){
                    self.getDeformity(context,self)
                }else{
                    self.getMutation(context,self)
                }
            }                        
        },        
        catchUpMethod:(context,self)=>{
            self.getMutation(context,self)
            self.getDeformity(context,self)
            let perk = context.stats.lists.perks.filter(perk => perk.name == "Mutant")[0]
            perk.longDesc += `\n\nMutations Gained:\n`

            context.stats.characterStats.abilityScore.strength += 2
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.constitution += 2
            context.stats.characterStats.abilityScore.intelligence -= 4
            context.stats.characterStats.abilityScore.wisdom -= 2
            context.stats.characterStats.abilityScore.charisma -= 4
            context.stats.characterStats.skills.intimidate += 6
            context.stats.characterStats.skills.climb += 2
            context.stats.characterStats.skills.swim += 2
            context.stats.characterStats.skills.diplomacy -= 12
            context.stats.characterStats.skills.heal -= 8
            context.stats.characterStats.misc.fortitude += 1
            context.stats.characterStats.misc.reflex += 1
            context.stats.characterStats.misc.will -= 4
            context.stats.statsForAbilities.ac.natural += 2
        },
        getMutation:(context,self)=>{
            self.createDialog(context,self.mutations)
        },
        getDeformity:(context,self)=>{
            self.createDialog(context,self.deformities)
        },
        createDialog: (context,options)=>{                        
            let chosen = []
            let choices = []
            for(let x = 0; x < 3; x++){
                let possible = Math.floor(Math.random()*options.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*options.length)
                chosen.push(possible)
                let option = options[possible]     
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Mutant")[0]
                        perk.longDesc += option.name + `: ` + option.description + `\n\n`
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                        }
                    })
                }
            }

            let custom = {title:"Mutant Mutation", options:choices}         
            context.customDialogArray.push(custom)            
        },

        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            let mutations = [...self.mutations]
            let deformities = [...self.deformities]
            mutations.forEach(mutation=>mutation.type = "Mutation")
            deformities.forEach(deformity=>deformity.type = "Deformity")
            return mutations.concat(deformities)
        },

        mutations:[{
            name:"Armored(Ex)",
            description:"Increase your racial natural armor bonus by +2",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.statsForAbilities.ac.natural += 2
            }
        },
        {
            name:"Mental Armor(Su)",
            description:"You gain a +1 deflection bonus to your armor class. As a swift action you can double your current deflection bonus to armor class.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.statsForAbilities.ac.deflection += 1
            }
        },
        {
            name:"Bulbous Eyes(Ex)",
            description:"Gain darkvision and low-light vision (60 feet)",                    
        },
        {
            name:"Exceptional Defense(Ex)",
            description:"One of your saves increases by +4",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let scores = ["reflex","fortitude","will"]
                let score = scores[Math.floor(Math.random()*3)]
                context.stats.characterStats.misc[score] += 4
            }
        },
        {
            name:"Celerity(Ex)",
            description:"As a swift action you gain the benefits of haste for 1 round. This ability can be used once every 1d4 rounds. The mutant gains a +2 bonus on Initiative checks.",                    
        },
        {
            name:"Breath Weapon(Ex)",
            description:"You can breath fire as a standard action once every 1d4+1 rounds. This deals 1d8 points of fire damage per level in a 15-ft cone, and allows a reflex save to halve the damage, DC= 10 + level/2 + Con. You can reduce the damage by 1d8 to increase the cones size by 5 feet (you can do this multiple times). This breath weapon affects you as well, although it always deals half damage to you, and you can make a fortitude saving throw to reduce it by half again.",                    
        },
        {
            name:"Spell Shell(Ex)",
            description:"You gain spell resistance 10 + HD.",                    
        },
        {
            name:"Echolocation(Ex)",
            description:"You gain blindsense 30 feet",                    
        },
        {
            name:"Extra Arm(Ex)",
            description:"You gain an extra arm. This extra arm can be used for anything a regular arm could be used for, even for taking attacks during a round. You can gain an extra attack with this arm when you are two-weapon fighting, but all attacks take a -2 penalty.",
        },
        {
            name:"Fast Healing(Ex)",
            description:"You gain fast healing 5",                    
        },
        {
            name:"Feral Bite(Ex)",
            description:"You gain a bite attack that deals 1d8 damage (or increase your bite by 1 size step)",                    
        },
        {
            name:"Feral Claws(Ex)",
            description:"You gain two claw attacks that deals 1d4 damage (or increase your claw damage by 1 size step)",                    
        },
        {
            name:"Hyperactive Hypothalamus(Ex)",
            description:"Whenever you roll a natural 20 and confirm it (if necessary), you gain a +1 bonus to all d20 rolls for 1 round. If you roll a natural 1 (and confirm it if necessary), you get a -1 penalty to all d20 rolls for 1 round. Whenever you gain a morale bonus increase the bonus by +1. You get a -2 penalty to all saving throws vs emotion and fear effects.",                    
        },
        {
            name:"Hyper Adrenaline Glands",
            description:"While in combat you can as a swift action gain temporary hit points equal to your constitution modifier 2x. These temporary hit points stack with each other, up to your constitution score, and last until you leave combat.",                    
        },
        {
            name:"Aquatic Adaptation(Ex)",
            description:"You can breathe underwater, and gain a swim speed equal to your land speed.",                    
        },
        {
            name:"Increased Speed(Ex)",
            description:"One of your movement speeds increases by 10 feet.",                    
        },
        {
            name:"Rage(Ex)",
            description:"You gain the ability to enter a rage like state (this stacks with rage, and rage powers can be used during it). You gain a +4 morale bonus to your strength and constitution, and cannot use spells and specific skills like with rage. Entering rage is a free action, and you can maintain it for 3 + con mod rounds a day. You do not become fatigued after raging with this ability. For each round you have spent raging this floor, you receive a -1 penalty to will saves.",                    
        },
        {
            name:"Leaping(Ex)",
            description:"You gain a +10 bonus to acrobatics checks, and always count as if you had a running start while jumping.",          
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.skills.acrobatics += 10
            }          
        },
        {
            name:"Resistance(Ex)",
            description:"Gain resistance 10 to an element of choice.",                    
        },
        {
            name:"Second Stomach",
            description:"You can drink a potion and store it in your second stomach for later. When you do so, the potion has no immediate effect, then anytime within the next 5 minutes you can cause the potion to effect you. If you are knocked unconcious the potion automatically takes effect. You can only have 1 potion stored this way at a time.",                    
        },
        {
            name:"Emergency Tumor",
            description:"You have a tumor somewhere on your body that contains a massive amount of your blood. Once per day as a swift action you can squeeze the tumor and getting the blood flowing through you body. When you do you gain temporary hit points equal to your constitution score which last 1 minute and the benefits of the haste spell for 1d4 rounds. Other players can also squeeze your tumor as a movement action as long as you are within their natural reach, it's kinda gross though.",                    
        },
        {
            name:"Hyper Specialization",
            description:"One of your skills increases by +15, all of your other skills reduce by -2.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let skills = ['acrobatics','diplomacy','bluff', 'climb', 'disableDevice', 'escapeArtist','fly', 'heal', 'intimidate', 'perception', 'senseMotive', 'spellcraft', 'stealth', 'perform', 'survival', 'knowArcana', 'knowPlanes', 'knowReligion','knowNature', 'craft', 'swim']
                let score = skills[Math.floor(Math.random()*skills.length)]
                context.stats.characterStats.skills[score] += 17
                skills.forEach(skill=>{
                    context.stats.characterStats.skills[skill] -= 2
                })
            } 
        },
        {
            name:"Adaptation",
            description:"Two of your skills increases by +8.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let skills = ['acrobatics','diplomacy','bluff', 'climb', 'disableDevice', 'escapeArtist','fly', 'heal', 'intimidate', 'perception', 'senseMotive', 'spellcraft', 'stealth', 'perform', 'survival', 'knowArcana', 'knowPlanes', 'knowReligion','knowNature', 'craft', 'swim']
                let score = skills[Math.floor(Math.random()*skills.length)]
                context.stats.characterStats.skills[score] += 8
                score = skills[Math.floor(Math.random()*skills.length)]
                context.stats.characterStats.skills[score] += 8
            } 
        },
        {
            name:"Rugged(Ex)",
            description:"Gain DR 3/-. This stacks with other DR",                    
        },
        {
            name:"Keen Senses",
            description:"You gain a +6 bonus to perception and the scent special ability",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.skills.perception += 6                        
            } 
        },
        {
            name:"Extra Leg",
            description:"You gain an additional leg, increasing your ground movement speed by 5 feet, and giving you a +2 bonus to your CMD against trip and bullrush checks.",                    
        },
        {
            name:"Sealed Mind(Ex)",
            description:"You gain a +4 bonus on saves against mind-affecting effects except fear.",                    
        },
        {
            name:"Me No Think Good",
            description:"When you are under the effects of a compulsion effect or a possession effect, instead of following out their dictated actions you have a 50% chance to take no actions on your turn instead. If this compulsion would only control part of your turns actions, you have a 50% chance to take no action instead of that action, but spend the rest of your turn normally.",                    
        },
        {
            name:"Ultra Instincts(Ex)",
            description:"As an immediate action when an attack is made against you that you are aware of, you can double your dodge bonus to armor class for that attack. By instead spending level/2 spell points you can double it for 1 round.",                    
        },
        {
            name:"Wings(Ex)",
            description:"You gain a fly speed 30 (poor).",                    
        },
        {
            name:"Filth(Ex)",
            description:"You gain a +4 bonus on saves vs disease and poison.",                    
        },
        {
            name:"Exceptional Ability(Ex)",
            description:"A random ability increases by +4",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let scores = ["strength","constitution","dexterity","intelligence","wisdom","charisma"]
                let score = scores[Math.floor(Math.random()*6)]
                context.stats.characterStats.abilityScore[score] += 4
            }
        },
        {
            name:"Resilient",
            description:"Your HD size increases by 4",
            hasCustomMethod:true,
            customMethod:(context)=>{                        
                context.stats.characterStats.misc.HDSize += 4
                context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
            }  
        },
        {
            name:"Legendary Proportions",
            description:"You become one size larger, taking the bonuses and penalties as if the spell enlarge person was cast on you.",                   
        },
        {
            name:"Tentacle",
            description:"You gain a tentacle natural attack. It is a secondary natural attack that deals 1d4 points of damage. It can't be used to hold or manipulate objects.",                   
        },
        // {
        //     name:"Tumor",
        //     description:"",                   
        // },
        {
            name:"Lonely Mutant",
            description:"Choose one of your arms, with that arm you can wield a two-handed weapons in it. If you do, it deals damage as if it were a one-handed weapon and takes a -4 penalty to attack. Because of the difference in the strength of your arms, if you wield two-handed weapons in both arms you get a -4 penalty to attack.",                   
        },
        {
            name:"Scrambled Organs",
            description:"Your organs are exceptionally unsual, you gain a 25% chance to ignore the additional damage from critical hits and precision damage. This doesn't stack with other fortification, but does increase it by 10%.",                   
        },
        {
            name:"Fluid Sack",
            description:"You have a sack that contains massive amounts of fluid that can be expelled once ever 2d4 rounds. As a standard action you can expel the fluid, if you do you move your speed, plus 100 feet in a straight line. This can even move you directly up. If you are wearing medium armor reduce this to movement speed plus 80, and in heavy it becomes movement speed plus 60 feet. You can expel the sack as a movement action to move half the distance, or as a swift action to move a quarter of the distance, and doesn't include your base movement speed.",                   
        },
        {
            name:"Unstable Form",
            description:"You are twice as likely to gain a mutation or deformity every level.",                   
        },
        {
            name:"Spellcarved",
            description:"You will gain a random spell when you gain this perk. The spell will not be based on your level.",
            hasCustomMethod:true,
            customMethod:(context)=>{                        
                let spell = spells[Math.floor(Math.random()*spells.length)]
                context.stats.lists.spells.push(spell)                  
            }
        },
        {
            name:"Magical Reservoir",
            description:"Gain an additional 1.5 spell points per level.",
            hasCustomMethod:true,
            customMethod:(context)=>{                        
                context.stats.characterStats.misc.spPerLevel += 1.5
                
            }  
        },],
        deformities:[
        {
            name:"Blind(Ex)",
            description:"The mutant can't see, and gains the blinded condition unless it possesses a means of seeing other than normal vision, darkvision, or low-light vision. This blindness can't be magically removed.",                    
        },
        {
            name:"Magically Inept",
            description:"You take a -4 penalty to all caster level checks and concentration checks and -25 to universal spell power, and -2% spell critical chance.",     
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.universal -= 25
                context.stats.characterStats.spellMastery.spellCriticalChance.universal -= 2
            }
        },
        {
            name:"Hemophilia",
            description:"You take twice as much damage from bleed damage. Whenever you are below 50% maximum hit points you take 1 point of bleed damage at the start of your turn (this isn't doubled, and stacks with other bleed damage). This deals an additional point of damage every 4 levels.",                    
        },
        {
            name:"Maladaptation",
            description:"Four random skills are reduce by -8.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let skills = ['acrobatics','diplomacy','bluff', 'climb', 'disableDevice', 'escapeArtist','fly', 'heal', 'intimidate', 'perception', 'senseMotive', 'spellcraft', 'stealth', 'perform', 'survival', 'knowArcana', 'knowPlanes', 'knowReligion','knowNature', 'craft', 'swim']
                for(let x = 0; x < 4; x++){
                    let score = skills[Math.floor(Math.random()*skills.length)]
                    context.stats.characterStats.skills[score] -=  8
                }
            } 
        },
        {
            name:"Talentless",
            description:"All of your skills reduce by -4.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let skills = ['acrobatics','diplomacy','bluff', 'climb', 'disableDevice', 'escapeArtist','fly', 'heal', 'intimidate', 'perception', 'senseMotive', 'spellcraft', 'stealth', 'perform', 'survival', 'knowArcana', 'knowPlanes', 'knowReligion','knowNature', 'craft', 'swim']
                skills.forEach(skill=>{
                    context.stats.characterStats.skills[skill] -= 4
                })
            } 
        },
        {
            name:"Thin Skinned",
            description:"Your natural armor bonus reduces by 4. This can even reduce your natural armor bonus below 0",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.statsForAbilities.ac.natural -= 4
            }
        },
        {
            name:"Deaf(Ex)",
            description:"The mutant can't hear, and gains the deafened condition. This deafness can't be magically removed.",                    
        },
        {
            name:"Water Dependant",
            description:"If you enter a floor, or when you gain this mutation, if it is not a floor containing a large amount of water you take 1 point of constitution drain.",                    
        },
        {
            name:"Tummy Hurt",
            description:"Whenever you drink a potion there is a 15% chance you cant keep it down, throwing it up immediately. If this happens the potion is expended, your actions wasted, and you gain no benefit for drinking it.",                    
        },
        {
            name:"Immunodisorder",
            description:"You take a -6 penalty on saves against disease, poison, sickened or nausea. You take twice as much ability damage from diseases. Whenever you are diseased or poisoned you also become sickened.",
        },
        {
            name:"Shattered Body",
            description:"All of your saves are reduced by -2.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.fortitude -= 2
                context.stats.characterStats.misc.will -= 2
                context.stats.characterStats.misc.reflex -= 2
            } 
        },
        {
            name:"Fragile(Ex)",
            description:"When the mutant fails a Fortitude save, it is staggered for 1 round. when you become staggered, you are instead stunned. Your fortitude save is reduced by -4", 
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.fortitude -= 4                        
            }                          
        },
        {
            name:"Fractured Mind(Ex)",
            description:"When the mutant fails a Will save, it is confused for 1 round. If the will save would stop you from acting, this confusion doesn't begin until you are able to act. Your will save is reduced by -4",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.will -= 4                        
            }       
        },
        {
            name:"Lame(Ex)",
            description:"The mutant's stunted body reduce its movement speeds by 10 feet, except magical movement speeds.",                    
        },
        {
            name:"I Forgor",
            description:"You lose a random perk or two feats. If you dont have something to lose you instead lose -2 to all mental scores. This wont remove your race.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let stuffToLose
                let loseCount = 1
                if(Math.random() > 0.5){
                    stuffToLose = context.stats.lists.perks.filter(perk=> perk.name != "Mutant")
                }else{
                    stuffToLose = context.stats.lists.feats
                    loseCount = 2
                }
                for(let x = 0; x < loseCount; x++){
                    if(stuffToLose.length > 0){
                        let thing = stuffToLose[Math.floor(Math.random()*stuffToLose.length)]
                        let index = context.stats.lists[thing.uiType].findIndex(thingIn=>thingIn === thing)
                        context.stats.lists[thing.uiType].splice(index,1)
                    }else{
                        context.stats.characterStats.abilityScore.intelligence -= 2
                        context.stats.characterStats.abilityScore.wisdom -= 2
                        context.stats.characterStats.abilityScore.charisma -= 2
                    }
                }                        
            }  
        },
        {
            name:"Light Blindness(Ex)",
            description:"You are blinded for 1 round if exposed to bright light, such as sunlight or the daylight spell. As long as you remain in an area with bright light you must make a fortitude save at the start of each turn DC 10+floor or you become blinded for 1 round.",                    
        },
        {
            name:"Mindless(Ex)",
            description:"Your intelligence and charisma lowers by 2 more, and you lose 1 spell point per level. You can no longer communicate verbally, and you can no longer use or be affected by language dependant spells or abilities. (you can still cast other spells normally)",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.abilityScore.intelligence -= 2
                context.stats.characterStats.abilityScore.charisma -= 2
                context.stats.characterStats.misc.spPerLevel -= 1
            }
        },
        {
            name:"Misshapen",
            description:"Your deformed body no longer fits armor properly, your armor gives half the normal armor bonus.",
        },
        {
            name:"Corrupt Soul",
            description:"You restore 25% less hit points from positive energy. You take 25% less damage from negative energy.",
        },
        {
            name:"Poor Ability",
            description:"You take a -4 penalty to a random ability score, and a -2 to another random ability score.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let scores = ["strength","constitution","dexterity","intelligence","wisdom","charisma"]
                let random1 = Math.floor(Math.random()*6)
                let random2 = Math.floor(Math.random()*6)
                while(random2 == random1 ) random2 = Math.floor(Math.random()*6)
                let score = scores[random1]
                context.stats.characterStats.abilityScore[score] -= 4
                score = scores[random2]
                context.stats.characterStats.abilityScore[score] -= 2
            }
        },
        {
            name:"Spasms",
            description:"When the mutant fails a Reflex save, for 1 round it can’t take attacks of opportunity or immediate actions and loses its Dexterity bonus to AC, on ranged attack rolls and attack rolls made using finesse weapons, and on ability checks and skill checks. Your reflex save is reduced by -4.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.reflex -= 4                        
            }
        },
        {
            name:"Useless Arm",
            description:"One of the mutant’s arms is malformed and useless, you cannot use it for anything.",
        },
        {
            name:"Inhuman Figure",
            description:"You lose 6 random wonderous item slots. If you get this again and lose the slot a second time, you take the penalty under the listed called shot special rules for the area the item is normally worn, but the penalty is permanent and cant be healed. Each additional time you lose the same slot the penalty increases one degree of success for the called shot (called shot-> critical called shot -> debilitating blow)",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let slots = ["Ring","Ring","Neck","Eyes","Belt","Hands","Head","Shoulders","Headband","Body","Feet","Wrist"]
                let chosen = []
                for(let x = 0; x < 6; x++){
                    let slotIndex = Math.floor(Math.random()*slots.length)
                    chosen.push(slots.splice(slotIndex,1))
                }
                let perk = context.stats.lists.perks.filter(perk => perk.name == "Mutant")[0]
                perk.longDesc += "Slots Lost: "
                for(let x = 0; x < chosen.length; x++){
                    perk.longDesc += chosen[x] + ", "
                }
                perk.longDesc += `\n\n`
                perk.longDesc = perk.longDesc.slice(0, -2);

            }
        },
        {
            name:"Alien Hyperfixation",
            description:"You can no longer wear clothing. Whenever you enter a store you lose 75 gold (you spent it on useless accessories that do nothing). If you do not have the required gold you become full of despair, taking a -2 penalty to all d20 rolls until you enter a store and spend the gold, including the gold you failed to spend the previous store.",
        },
        {
            name:"Battery Powered",
            description:"You have a new organ that runs on magical energy. You can spend a movement action to absorb a wonderous item, this provokes attacks of opportunity. When you do, you gain a +1 bonus to a physical score of your choice, +1 for each rarity above common it is. This lasts for the rest of the floor. If you have no yet absorbed a wonderous item this floor, you gain a -4 penalty to all physical ability scores.",
        },
        {
            name:"Vulnerability",
            description:"You become vulnerable to a random energy type.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let elems = ["Fire",'Cold','Electricity','Acid']
                let vulnerability = elems[Math.floor(Math.random())]
                let perk = context.stats.lists.perks.filter(perk => perk.name == "Mutant")[0]
                perk.longDesc += "Vulnerability: " + vulnerability + `\n\n`
                //context.stats.characterStats.misc.HDSize -= 6
            }  
        },
        {
            name:"Weakened",
            description:"Your HD size decreases by 6",
            hasCustomMethod:true,
            customMethod:(context)=>{                        
                context.stats.characterStats.misc.HDSize -= 6
                context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
            }  
        },
    ],    
    },
    {
        rarity:"class",
        name:"High Elf",
        longDesc:`These elves live a secluded and prosperous life studying magic, which they excel at even compared to their peers, however their secluded sedentary lives have left them unprepared for real combat situations and exceptionally fragile. Their sense of superiority and disgust for other 'lesser' beings also makes them very unlikable to most other races.
        \nAbility Scores: +4 Intelligence, +2 Wisdom, -3 Constitution, -2 Charisma, -4 Strength
        \nDefenses: Gain a +2 bonus on saves vs spells
        \nSkills: +6 spellcraft, +4 knowledge arcana, knowledge Planes, +2 knowledge Nature, sense motive, -8 Knowledge Religion, -6 perform, -4 diplomacy, -2 acrobatics,
        \nSpecial: Increase the DC of all spells and magic perks by 1, gain +2 to all caster level checks, but a -4 penalty to concentration checks. Gain 15 universal spell power, 2% universal spell critical chance, and 15 universal spell critical damage.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: normal
        \nBonus Rolls: You gain an additional spell, plus an additional spell every 3rd level, and 2 spell points per level.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %3 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
            }            
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
            context.stats.characterStats.abilityScore.intelligence += 4
            context.stats.characterStats.abilityScore.wisdom += 2
            context.stats.characterStats.abilityScore.constitution -= 3
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.abilityScore.strength -= 4
            context.stats.characterStats.misc.spPerLevel += 2
            context.stats.characterStats.skills.spellcraft += 6
            context.stats.characterStats.skills.knowArcana += 4
            context.stats.characterStats.skills.knowPlanes += 4
            context.stats.characterStats.skills.knowNature += 2
            context.stats.characterStats.skills.senseMotive += 2
            context.stats.characterStats.skills.acrobatics -= 2
            context.stats.characterStats.skills.diplomacy -= 4
            context.stats.characterStats.skills.perform -= 6
            context.stats.characterStats.skills.knowReligion -= 8
            context.stats.characterStats.spellMastery.spellPower.universal += 15
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
            context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
        },
    },
    {
        rarity:"class",
        name:"Vanara",
        longDesc:`Vanara are fully humanoid monkeys. They have a long prehensile tail, and feet made for climbing.
        \nAbility Scores: +2 Dexterity, +1 Wisdom, -2 Charisma
        \nDefenses: Gain a +2 bonus to reflex saves, and a +4 bonus to your CMD against trips.
        \nSkills: +4 climb, acrobatics, +2 stealth, escape artist, -4 swim, -2 diplomacy, bluff
        \nSpecial: Vanara have a prehensile tail, they cannot use it to wield weapons or shields, but they can use it to hold gear and potions. Additionally once per combat they can withdraw gear or a potion as a swift action, this does not provoke. 
        \nSize: medium
        \nSpeed: 30 feet, 20 foot climb
        \nVision: Normal
        \nBonus Rolls: You gain a Ki Perk every 6 levels`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Ki Power"})); 
            }            
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.charisma -= 2
            context.stats.characterStats.skills.climb += 4
            context.stats.characterStats.skills.acrobatics += 4
            context.stats.characterStats.skills.stealth += 2
            context.stats.characterStats.skills.escapeArtist += 2
            context.stats.characterStats.skills.swim -= 4
            context.stats.characterStats.skills.diplomacy -= 4
            context.stats.characterStats.skills.bluff -= 4
            context.stats.characterStats.misc.reflex += 2
        },
    },
    {
        rarity:"class",
        name:"Dragonborn",
        longDesc:`Dragonborn are humanoid dragons, they are noble and powerful, with many fearsome powers from their draconic heritage, though most are still sociable and kind, though also large and clumsy.
        \nAbility Scores: +2 Strength, +1 Charisma, -5 Dexterity
        \nDefenses: Gain a +2 racial bonus to natural armor, +2 bonus on saves vs magical sleep and paralysis, and depending on heritage resistance 30 to one element and vulnerability to another element. 
        \nSkills: +4 intimidate, perception, +2 knowledge religion, -8 disable device, -6 stealth, acrobatics, -2 sense motive, knowledge nature
        \nSpecial: When you select a dragonborn you will pick a heritage which will determine your element for your abilities. You gain a breath weapon that you can use as a standard action that you can use once every 2d4 rounds. It deals 1d6 damage of your element per level, reflex DC 10+level/2+con for half. You also gain a bite attack which deals 1d6 damage, which is a primary attack.
        \nSize: medium
        \nSpeed: 30 feet, 20ft fly (poor)
        \nVision: Low-light Vision, Darkvision
        \nBonus Rolls: Each level you gain 10 gold`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.stats.gold += 10
        },
        catchUpMethod:(context,self)=>{
            self.getChoice(context,self)
            let perk = context.stats.lists.perks.filter(perk => perk.name == "Dragonborn")[0]
            perk.longDesc += `\n\nHeritage:\n`
            context.stats.characterStats.abilityScore.strength += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.dexterity -= 5
            context.stats.characterStats.skills.intimidate += 4
            context.stats.characterStats.skills.perception += 4
            context.stats.characterStats.skills.knowReligion += 2
            context.stats.characterStats.skills.disableDevice -= 8
            context.stats.characterStats.skills.stealth -= 6
            context.stats.characterStats.skills.acrobatics -= 6
            context.stats.characterStats.skills.senseMotive -= 2
            context.stats.characterStats.skills.knowNature -= 2
            context.stats.statsForAbilities.ac.natural += 2
        },
        getChoice: (context,self)=>{
            let heritages = self.heritages
            let worldDragon = {
                name:"World",
                description:`\nElement: Untyped, Vulnerability: None
                \nBreath Weapon: 30ft Cone
                \nStats: +1 Strength, +1 Constitution, -1 Dexterity
                \nSpecial: You become large and gain all bonuses as if you had enlarge person cast on you. Your fly speed becomes 10ft(clumsy). You have no elemental resistance or vulnerability, your breath weapon does untyped damage and it deals 1d8 per level, but can only be used once every 2d6 rounds.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 1
                    context.stats.characterStats.abilityScore.constitution += 1
                    context.stats.characterStats.abilityScore.dexterity -= 1
                }
            }
            if(Math.random() > 0.75) heritages.push(worldDragon)
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*heritages.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*heritages.length)
                chosen.push(possible)
                let option = heritages[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Dragonborn")[0]
                        perk.longDesc += option.name + ": " + option.description + "\n\n"
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                        }
                    })
                }
                
            }
            let custom = {title:"Dragonborn Heritage", options:choices}         
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            return self.heritages
        },
        heritages:[
            {
                name:"Gold",
                description:`\nElement: Fire, Vulnerability: Cold
                \nBreath Weapon: 30ft cone
                \nStats: +1 Strength, +2 Wisdom, -1 Dexterity, +10 fire spell power, +10 positive spell power, -10 cold spell power, -10 negative spell power
                \nSpecial: You gain the Divine Favor spell, when you reach level 9 you also gain Divine Power`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Divine Favor")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Divine Power")[0])
                    context.stats.characterStats.abilityScore.strength += 1
                    context.stats.characterStats.abilityScore.wisdom += 2
                    context.stats.characterStats.abilityScore.dexterity -= 1
                    context.stats.characterStats.spellMastery.spellPower.fire += 10
                    context.stats.characterStats.spellMastery.spellPower.positive += 10
                    context.stats.characterStats.spellMastery.spellPower.negative -= 10
                    context.stats.characterStats.spellMastery.spellPower.cold -= 10
                }
            },
            {
                name:"Silver",
                description:`\nElement: Cold, Vulnerability: Fire
                \nBreath Weapon: 15ft cone
                \nStats: -1 Charisma +1 Intelligence, +1 Dexterity, +2 Will saves, +10 cold spell power, -10 fire spell power
                \nSpecial: Gain a random buff/utility spell, and an extra spell point per level.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{utility:true,buff:true}}}))
                    context.stats.characterStats.abilityScore.charisma -= 1
                    context.stats.characterStats.abilityScore.intelligence += 1
                    context.stats.characterStats.abilityScore.dexterity += 1
                    context.stats.characterStats.misc.will += 2
                    context.stats.characterStats.misc.spPerLevel += 1 
                    context.stats.characterStats.spellMastery.spellPower.cold += 10
                    context.stats.characterStats.spellMastery.spellPower.fire -= 10
                }
            },
            {
                name:"Bronze",
                description:`\nElement: Electricity, Vulnerability: Cold
                \nBreath Weapon: 30ft line
                \nStats: -2 Charisma, +3 Intelligence, +2 all knowledges, +4 swim, -4 fly, +10 electricity spell power, -10 cold spell power
                \nSpecial: You can add your highest mental stat to the damage of your breath weapon, and it scales with electric spell power. Your breath weapon becomes usable every 1d3+1 rounds.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma -= 2
                    context.stats.characterStats.abilityScore.intelligence += 3
                    context.stats.characterStats.skills.knowReligion += 2
                    context.stats.characterStats.skills.knowNature += 2
                    context.stats.characterStats.skills.knowArcana += 2
                    context.stats.characterStats.skills.knowPlanes += 2
                    context.stats.characterStats.skills.swim += 4
                    context.stats.characterStats.skills.fly -= 4
                    context.stats.characterStats.spellMastery.spellPower.electricity += 10
                    context.stats.characterStats.spellMastery.spellPower.cold -= 10
                }
            },
            {
                name:"Copper",
                description:`\nElement: Acid, Vulnerability: Electricity
                \nBreath Weapon: 30ft line
                \nStats: +2 Charisma, +2 diplomacy, perform, +10 acid spell power, -10 electricity spell power
                \nSpecial: Gain +2 on saves against fear. Once per floor when a creature you can see fails a save vs a fear effect, you can as an immediate action roll a diplomacy or perform check and use that in place of their save.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma += 2
                    context.stats.characterStats.skills.perform += 2
                    context.stats.characterStats.skills.diplomacy += 2
                    context.stats.characterStats.spellMastery.spellPower.acid += 10
                    context.stats.characterStats.spellMastery.spellPower.electricity -= 10
                }
            },
            {
                name:"Brass",
                description:`\nElement: Fire, Vulnerability: Cold
                \nBreath Weapon: 15ft Cone
                \nStats: +2 Charisma, -2 Wisdom, +10 fire spell power, -10 cold spell power
                \nSpecial: Once per floor when making a check for treasure you can roll a d100, on 75+ treat it as if you had rolled a natural 20. Gain 25 gold.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma += 2
                    context.stats.characterStats.abilityScore.wisdom -= 2
                    context.stats.gold += 25
                    context.stats.characterStats.spellMastery.spellPower.fire += 10
                    context.stats.characterStats.spellMastery.spellPower.cold -= 10
                }
            },
            {
                name:"Red",
                description:`\nElement: Fire, Vulnerability: Cold
                \nBreath Weapon: 30ft Cone
                \nStats: +2 Strength, -2 Dexterity, +4 Intimidate, +10 fire spell power, 15% fire spell critical damage, -25 cold spell power
                \nSpecial: Your Bite attack base damage becomes 1d8 damage, and deals 1.5x strength damage, or 1x strength damage if its a secondary attack.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 2
                    context.stats.characterStats.abilityScore.dexterity -= 2
                    context.stats.characterStats.skills.intimidate += 4
                    context.stats.characterStats.spellMastery.spellPower.fire += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire += 15
                    context.stats.characterStats.spellMastery.spellPower.cold -= 25
                }
            },
            {
                name:"Blue",
                description:`\nElement: Electricity, Vulnerability: Acid
                \nBreath Weapon: 30ft line
                \nStats: +2 Intelligence, -1 Strength, +4 bluff, +10 electricity spell power, +5 universal spell power, -10 acid spell power
                \nSpecial: +1 to the DC of control spells. If you cast a control spell and no creature fails a save against it (if a save was rolled) you are shaken for 2d4 rounds.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.intelligence += 2
                    context.stats.characterStats.abilityScore.strength -= 1
                    context.stats.characterStats.skills.bluff += 4
                    context.stats.characterStats.spellMastery.spellPower.electricity += 10
                    context.stats.characterStats.spellMastery.spellPower.universal += 5
                    context.stats.characterStats.spellMastery.spellPower.acid -= 10
                }
            },
            {
                name:"Black",
                description:`\nElement: Acid, Vulnerability: Electricity
                \nBreath Weapon: 30ft line
                \nStats: +8 Dexterity, +2 Intelligence, -4 Charisma, -2 Strength, +12 stealth, +8 acrobatics, +4 swim, +2 intimidate, -4 fly, diplomacy, +10 acid spell power, -10 electricity spell power
                \nSpecial: Your bite attack deals 1d6+con mod acid damage`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 8
                    context.stats.characterStats.abilityScore.intelligence += 2
                    context.stats.characterStats.abilityScore.charisma -= 4
                    context.stats.characterStats.abilityScore.strength -= 2
                    context.stats.characterStats.skills.stealth += 12
                    context.stats.characterStats.skills.acrobatics += 6
                    context.stats.characterStats.skills.swim += 4
                    context.stats.characterStats.skills.intimidate += 2
                    context.stats.characterStats.skills.fly -= 4
                    context.stats.characterStats.skills.diplomacy -= 4
                    context.stats.characterStats.spellMastery.spellPower.acid += 10
                    context.stats.characterStats.spellMastery.spellPower.electricity -= 10
                }
            },
            {
                name:"White",
                description:`\nElement: Cold, Vulnerability: Fire
                \nBreath Weapon: 15ft Cone
                \nStats: +1 Strength, +2 Constitution, -2 Charisma, -2 Intelligence, -1 Wisdom, +10 cold spell power, -10 fire spell power
                \nSpecial: +1 Natural Armor, and your bite attack has a x3 critical damage multiplier.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 1
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.abilityScore.intelligence -= 2
                    context.stats.characterStats.abilityScore.charisma -= 2
                    context.stats.characterStats.abilityScore.wisdom -= 1
                    context.stats.statsForAbilities.ac.natural += 1
                    context.stats.characterStats.spellMastery.spellPower.cold += 10
                    context.stats.characterStats.spellMastery.spellPower.fire -= 10
                }
            },
            {
                name:"Green",
                description:`\nElement: Acid, Vulnerability: Fire
                \nBreath Weapon: 15ft Cone
                \nStats: +1 Intelligence, +1 Wisdom, +10 acid spell power, 2% acid spell critical chance, -10 fire spell power
                \nSpecial: When you roll a natural 1 that results in a failure you gain a +2 bonus to all rolls for 1 round.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.intelligence += 1
                    context.stats.characterStats.abilityScore.wisdom += 1
                    context.stats.characterStats.spellMastery.spellPower.acid += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid += 2
                    context.stats.characterStats.spellMastery.spellPower.fire -= 10
                }
            },
            {
                name:"Time",
                description:`\nElement: Electricity, Vulnerability: Cold
                \nBreath Weapon: 15ft Cone
                \nStats: +2 Intelligence, +10 electricity spell power, +5 universal spell power
                \nSpecial: Gain a +4 bonus to initiative checks, and a +2 bonus on saves that would stagger you. Once per day you can cause any creature you can see to reroll a d20 roll. At level 10 and 20 you can do this an additional time per floor. This is a free action you can do even when not your turn.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.intelligence += 2
                    context.stats.characterStats.spellMastery.spellPower.electricity += 10
                    context.stats.characterStats.spellMastery.spellPower.universal += 5
                }
            },
            {
                name:"Void",
                description:`\nElement: Cold, Vulnerability: Fire
                \nBreath Weapon: 15ft Cone
                \nStats: +1 Strength, +2 Dexterity, -2 Charisma, -1 Wisdom, +10 cold spell power, +15% cold spell critical damage, -25 fire spell power
                \nSpecial: You can change the save for your breath weapon to be a will save, if you do so, all creatures who fail the save are also shaken for 1 round plus 1 per 5 levels. Your fly speed becomes 30ft(poor)`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 1
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.abilityScore.wisdom -= 1
                    context.stats.characterStats.abilityScore.charisma -= 2
                    context.stats.characterStats.spellMastery.spellPower.cold += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold += 15
                    context.stats.characterStats.spellMastery.spellPower.fire -= 25
                }
            },
            {
                name:"Solar",
                description:`\nElement: Fire, Vulnerability: Cold
                \nBreath Weapon: 40ft line
                \nStats: +1 Strength, +1 dexterity, +10 fire spell power, +10 positive spell power, -25 cold spell power
                \nSpecial: Once per floor you can turn into a beam of light and instantly teleport up to 10ft per level. At level 8 and 16 you can do this an additional time per floor. It is a movement action to do so and does not provoke. Your breath weapon treats creatures with fire resistance as it being 10 lower.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 1
                    context.stats.characterStats.abilityScore.dexterity += 1
                    context.stats.characterStats.spellMastery.spellPower.fire += 10
                    context.stats.characterStats.spellMastery.spellPower.positive += 10
                    context.stats.characterStats.spellMastery.spellPower.cold -= 25
                }
            },
            {
                name:"Lunar",
                description:`\nElement: Cold, Vulnerability: Fire
                \nBreath Weapon: 40ft line
                \nStats: +1 Charisma, +1 Dexterity, +6 stealth, +10 cold spell power, +2% cold spell critical chance, -25 fire spell power
                \nSpecial: You gain a deflection bonus to your armor class against rays spells equal to your highest mental stat. Once per day if a creature fails to hit you with a ray because of this additional armor class you can spend an immediate action to reflect it back at them as the 'spell turning' spell. Your breath weapon treats creatures with cold resistance as it being 10 lower.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma += 1
                    context.stats.characterStats.abilityScore.dexterity += 1
                    context.stats.characterStats.skills.stealth += 6
                    context.stats.characterStats.spellMastery.spellPower.cold += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold += 2
                    context.stats.characterStats.spellMastery.spellPower.fire -= 25
                }
            },
            {
                name:"Vortex",
                description:`\nElement: Fire, Vulnerability: Cold
                \nBreath Weapon: 15ft Cone
                \nStats: +2 Charisma, +10 fire spell power, -10 cold spell power
                \nSpecial: On your turn your bite attack has a reach of 15 feet. Your fly speed becomes 30ft(average)`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma += 2
                    context.stats.characterStats.spellMastery.spellPower.fire += 10
                    context.stats.characterStats.spellMastery.spellPower.cold -= 10
                }
            },
        ]
    },
    {
        rarity:"class",
        name:"Vishkanya",
        longDesc:`Vishkanyas are a race of exotic humanoids with poisonous blood. Possessed of an alien beauty, these graceful humanoids see the world through serpentine eyes of burnished gold.
        \nAbility Scores: +2 Dexterity +2 Charisma, -4 Wisdom
        \nDefenses: A vishkanya has a racial bonus on saving throws against poison equal to its Hit Dice.
        \nSkills: +4 perception, escape artist, stealth, +2 diplomacy, bluff, perform, -6 survival, sense motive, -4 heal
        \nSpecial: A number of times per day equal to his Constitution modifier (minimum 1/day), a vishkanya can envenom a weapon that he wields with his toxic saliva or blood. Applying venom in this way is a swift action. Venom: Injury; save Fort DC 10 + 1/2 the Hit Dice + the Con mod; frequency 1/round for 6 rounds; effect 1d2 Dex; cure 1 save.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision
        \nBonus Rolls: Every 5 levels they gain a skill/misc stat roll`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats",options:{type:{skills:true,misc:true}}})); 
            }            
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.wisdom -= 4
            context.stats.characterStats.skills.perception += 4
            context.stats.characterStats.skills.escapeArtist += 4
            context.stats.characterStats.skills.stealth += 4
            context.stats.characterStats.skills.diplomacy += 2
            context.stats.characterStats.skills.perform += 2
            context.stats.characterStats.skills.bluff += 2
            context.stats.characterStats.skills.heal -= 4
            context.stats.characterStats.skills.senseMotive -= 6
            context.stats.characterStats.skills.survival -= 6
        },
    },
    {
        rarity:"class",
        name:"Android",
        longDesc:`Androids are artificial humans, but with a real soul placed inside. Beep Boop.
        \nAbility Scores: +2 Dexterity +2 Intelligence, -4 Charisma
        \nDefenses: Gains +4 racial bonus on all saving throws against mind-affecting effects, paralysis, poison, and stun effects, and immunity to disease and sleep.
        \nSkills: +2 perception, -6 to sense motive, heal, -2 diplomacy, survival
        \nSpecial: Once per day as an immediate action, an android can cause their nanites to surge, granting a bonus equal to 3 + the android’s level on any one d20 roll; this ability must be activated before the roll is made. Heal checks cannot be made to heal you, but craft checks can.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision, Darkvision
        \nBonus Rolls: Every 5 levels gain a ability score/misc stat roll`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats",options:{type:{abilityScore:true,misc:true}}})); 
            }            
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.abilityScore.dexterity += 2
            context.stats.characterStats.abilityScore.intelligence += 2
            context.stats.characterStats.abilityScore.charisma -= 4
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.diplomacy -= 2
            context.stats.characterStats.skills.survival -= 2
            context.stats.characterStats.skills.heal -= 6
            context.stats.characterStats.skills.senseMotive -= 6
        },
    },
    {
        rarity:"class",
        name:"Ganzi",
        longDesc:`Ganzi are humanoids who have been mutated by exposure to chaotic energy, each with a different mutation.
        \nAbility Scores: +1 Constitution, +2 Charisma, -2 Intelligence
        \nDefenses: Gain acid, electricity, sonic resistance 5, and +2 bonus on saves against polymorph spells.
        \nSkills: +4 Sense Motive, Escape Artist, +2 Survival, Acrobatics, -8 Heal, -4 Knowledge Nature, Disable Device
        \nSpecial: Gain a Ganzi Oddity
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Normal
        \nBonus Rolls: Gain an additional Ganzi Oddity every 8 levels.`,
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                self.getChoice(context,self)
            }
        },
        catchUpMethod:(context, self)=>{
            self.getChoice(context,self)
            let perk = context.stats.lists.perks.filter(perk => perk.name == "Ganzi")[0]
            perk.longDesc += `\n\nOddities Gained:\n`
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.constitution +=1
            context.stats.characterStats.abilityScore.intelligence -= 2
            context.stats.characterStats.skills.senseMotive += 4
            context.stats.characterStats.skills.escapeArtist += 4
            context.stats.characterStats.skills.survival += 2
            context.stats.characterStats.skills.acrobatics += 2
            context.stats.characterStats.skills.heal -= 8
            context.stats.characterStats.skills.knowNature -= 4
            context.stats.characterStats.skills.disableDevice -= 4
        },
        getChoice: (context,self)=>{    
            let oddities = self.oddities
            let choices = []
            if(Math.random() > 0.95){
                if(Math.random() > 0.5){
                    choices[0] = {
                        title:"Chaos Blessed",
                        id:0,
                        description:"You are blessed by the chaos, you gain a +2 bonus to all ability scores.",
                        hasCustomMethod:true,
                        method:(context)=>{
                            let perk = context.stats.lists.perks.filter(perk => perk.name == "Ganzi")[0]
                            perk.longDesc += "Chaos Blessed: You are blessed by the chaos, you gain a +2 bonus to all ability scores. \n\n"
                            context.stats.characterStats.abilityScore.strength += 2
                            context.stats.characterStats.abilityScore.dexterity += 2
                            context.stats.characterStats.abilityScore.constitution += 2
                            context.stats.characterStats.abilityScore.intelligence += 2
                            context.stats.characterStats.abilityScore.wisdom += 2
                            context.stats.characterStats.abilityScore.charisma += 2
                        }
                    }
                }else{
                    choices[0] = {
                        title:"Chaos Scarred",
                        id:0,
                        description:"You were horrifically scarred by your exposure to the chaos energy, leaving you weakened, but with additional protean powers, reduce all of your abilty scores by 2. You gain 50% chance to ignore additional damage from critical hits and precision damage, and your electricity, acid, and sonic resistance increases to 20.",
                        hasCustomMethod:true,
                        method:(context)=>{
                            let perk = context.stats.lists.perks.filter(perk => perk.name == "Ganzi")[0]
                            perk.longDesc += "Chaos Scarred: You were horrifically scarred by your exposure to the chaos energy, leaving you weakened, but with additional protean powers, reduce all of your abilty scores by 2. You gain 50% chance to ignore additional damage from critical hits and precision damage, and your electricity, acid, and sonic resistance increases to 20"
                            context.stats.characterStats.abilityScore.strength -= 2
                            context.stats.characterStats.abilityScore.dexterity -= 2
                            context.stats.characterStats.abilityScore.constitution -= 2
                            context.stats.characterStats.abilityScore.intelligence -= 2
                            context.stats.characterStats.abilityScore.wisdom -= 2
                            context.stats.characterStats.abilityScore.charisma -= 2
                        }
                    }
                }
            }else{
                let chosen = []
                for(let x = 0; x < 3; x++){
                    let possible = Math.floor(Math.random()*oddities.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*oddities.length)
                    chosen.push(possible)
                    let option = oddities[possible]                    
                    choices[x] = {
                        title:option.name,
                        description:option.description,
                        id:x,
                        method:(context =>{
                            let perk = context.stats.lists.perks.filter(perk => perk.name == "Ganzi")[0]
                            perk.longDesc += option.name + `: ` + option.description + `\n\n`
                            if(option.hasCustomMethod){
                                option.customMethod(context)
                            }
                        })
                    }
                }
            }
            let custom = {title:"Ganzi Oddity", options:choices}         
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            return self.oddities
        },
        oddities: [
            {
                name:"Chaos Champion(Su)",
                description:"You can smite law once per day as a swift action, targeting a lawful foe. You add your Charisma modifier as a bonus on attack rolls and gains a bonus on damage rolls equal to your Hit Dice. This smite lasts 3 rounds, and does not allow you to bypass its damage reduction or grant you a bonus to your armor class.",
            },
            {
                name:"Entropic Flesh(Ex)",
                description:"You gain a +4 bonus on Escape Artist checks and a +2 to CMD against grapple combat maneuvers. Additionally, when you are affected by a hostile transmutation effect (such as polymorphing or petrification), you can attempt a new saving throw at the start of your next turn to end the effect. You gain a +4 bonus on this second saving throw, but if you fail, the transmutation effect persists as long as it normally would.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.skills.escapeArtist += 4
                }
            },
            {
                name:"Prehensile Tail(Ex)",
                description:"Your tail becomes prehensile, you cannot use it to wield weapons or shields, but you can use it to hold gear and potions. Additionally once per day you can withdraw gear or a potion as a swift action, and it doesn't provoke. On the round you do so, you gain a +4 dodge bonus to armor class.",
            },
            {
                name:"Slamming Tail(Ex)",
                description:"Your tail becomes massive and thick, and you can use to make tail slap attacks. It is a secondary natural attack that deals 1d6 B damage",
            },
            {
                name:"Mischievous Tail(Ex)",
                description:"Your tail becomes mischievous with a chaotic and independant nature that causes it to perform mischief by its own will. As a swift action you can order it to attempt to trip or disarm a creature within your natural reach, using all of your normal modifiers and abilities, however it does not provoke attacks of opportunity, however it has a 25% chance to instead attempt to trip or disarm you (it will choose whichever action it believes is more inconvenient to you).",
            },
            {
                name:"Larcenous Tail(Ex)",
                description:"Your tail becomes kleptomanic with an independant and greedy nature that causes it to steal by its own will. Whenever you attempt to retrieve something from the bag roll a d100, on a result of below 1-10 the item you were looking for has been mysteriously moved and your action to retrieve it is wasted, on a result of 95-100 the tail somehow managed to 'find' an extra one at some point and when you retrieve it it doesn't expend the item. The replication effect cannot activate on an item you have already drawn this floor (even copies of the item).",
            },
            {
                name:"Strong Tail(Ex)",
                description:"Your tail becomes strong and wide and can lift you up and be balance on. As a swift action you can lift yourself up an amount equal to your height (5ft for medium, 10 for large, etc.), and a swift action to return to the ground, this movement does not provoke attacks of opportunity. You can also fall to the ground as a free action, but unless you succeed an acrobatics check DC 15 or you fall prone. While you are using this ability, you cannot activate or use any other abilities your tail may have (except Larcenous Tail becuase that happened earlier when you weren't looking). The squares your tail occupies count as you for any effects or targetting, and it only gains half your armor's armor bonus to its armor class. If you are not balancing on your tail you gain a +4 bonus to your CMD against trip attacks, if you are balancing on your tail this instead becomes a penalty. If your tail is also massive or mischevious you increase the reach of its attacks by 5 feet.",
            },
            {
                name:"Quibble(Su)",
                description:"Once per day as an immediate action, a ganzi can twist probability and alter the luck of a single creature within 20 feet, forcing it to reroll a single d20 roll it has just made. The target must take the second result, even if it is worse. A ganzi can use this ability after the target has rolled but must use it before the GM declares whether the roll was a success or failure. You can activate this an additional time at level 10 and 20.",
            },
            {
                name:"Shapeshifter(Sp)",
                description:"You gain the 'Alter Self' spell. Whenever you are under the effects of a polymorph spell you gain a bonus to a random physical ability score equal to the level of the spell. You gain an additional +2 bonus on saves against hostile polymorph effects.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Alter Self")[0])
                }
            },
            {
                name:"Valkyrie Soul(Ex)",
                description:"You gain a +1 bonus on attack and damage rolls with one and two handed weapons, and bows. Once per day when an ally within 30 feet is killed you can use an immediate action to heal them 4d8 + highest mental hit points, this can potentially return them to life.",
            },
            {
                name:"Valkyrie's Zeal(Su)",
                description:"You gain a deflection modifier to your armor class equal to your Charisma modifier (Only Charisma). Whenever you are successfully attacked you lose this bonus for 1d6 rounds and become shaken for the same duration. If you have chaos champion, while it is in effect you cannot lose your deflection modifier to armor class from this ability, and it is always active.",
            },
            {
                name:"Protean Eyes",
                description:"You gain Blindsense 10 feet.",
            },
            {
                name:"Hegessik's Reach",
                description:"Once per combat you can use a standard action to make a single melee attack with a range of 60 feet. Use rules as if you were making the attack with a reach weapon (though this doesn't make it count as a reach weapon).",
            },
            {
                name:"Leaching Eye",
                description:"Once per day you open your third hidden eye as a standard action, when you do all creatures within 30 feet must make a will save DC 10 + level + highest mental or take 1d3 wisdom damage, for every point of wisdom damage you do, you restore 3 spell points.",
            },
            {
                name:"True Freedom(Sp)",
                description:"Once per day as a swift action you can cause yourself to become affected as the freedom of movement spell for 1d4 rounds.",
            },
            {
                name:"Spellwarp(Su)",
                description:"Once per day when a single creature is targeted by a spell, you can spend an immediate action to twist that spell, it now randomly targets a creature within 100 feet.",
            },
            {
                name:"Glory and Valor(Ex)",
                description:"You are descended from the einherji, the worthy warriors of chaos, and once per day you can call upon that nature to unleash a mighty battle cry as a standard action, for the next minute the first time each round you successfully land an attack you heal hit points equal to half your level. On a confirmed critical this instead heals your level worth of hit points and its duration increases by 1 round, on a natural one on any d20 roll this ability immediately ends.",
            },
            {
                name:"Einherji's Challenge(Ex)",
                description:"You are descended from the einherji, the worthy warriors of chaos, and once per combat you can call upon that nature to challenge a creature to single combat as a swift action, You attempt an intimidate check to demoralize that creature. If the check succeeds, the target is shaken and you gain a +2 bonus on attack rolls and damage rolls against that target. For the duration of the challenge, you must attack that target, and takes a –2 penalty to its AC, except against attacks made by the target, for who you gain a +2 morale bonus to armor class. The challenge (and the shaken condition) remains in effect until the target successfully attacks you in melee combat, the target is dead or unconscious, or the combat ends. If you successfully kill a creature that is currently challenged by you, you gain a +2 morale bonus on all d20 rolls for 3 rounds.",
            },
            {
                name:"Einherji's Thirst(Ex)",
                description:"If on the previous round you attacked and dealt damage with a melee attack, you gain fast healing 5. If you are in combat and did not deal or take damage on your previous round, you lose 1 hit point, and your next charge attack gains a +1 bonus to its attack and damage (doesn't stack).",
            },
            {
                name:"Chaotic Resistance",
                description:`At the start of each floor you roll a 1d8, each result being equal to an element. You gain resistance 10 against that element, this stacks with any resistance you already have from your race. As a standard action you can reroll the resistance you gained.\n1: Fire\n2: Cold\n3: Electricity\n4: Acid\n5: Sonic\n6: Untyped\n7: Negative Energy \n8:None`,
            },
            {
                name:"Anarchic Arcana",
                description:`At the start of each floor you roll 3d26 (use custom roller if need be), each number corresponding with a letter, if a spell in the Akashic Paths includes the 3 letters in the order you rolled them, you can choose one of those spells, for the rest of the floor that spell counts as being on your spell list. As a movement action you can spend level/2 spell points to reroll the 3d26, however once a spell becomes available for you to choose from you are no longer able to reroll. If the spell is of a higher level than you have a spell known, it costs double the spell points.`,
            },
            {
                name:"Heart of Chaos",
                description:`As a free action you can cause yourself to be treated as if your alignment is chaotic for 1 round. This does not change your good-evil alignment. You can do this once per day, plus an additional time every 6 levels. If an ability has a duration and is based on your alignment, it acts as it normally would once this ability ends.`,
            },
            {
                name:"Creative Prodigy",
                description:`You gain +6 to Bluff, Performance and Craft`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.skills.perform += 6
                    context.stats.characterStats.skills.craft += 6
                    context.stats.characterStats.skills.bluff += 6
                }
            },
            {
                name:"Amorphous Limb(Su)",
                description:"Every 1d4 rounds as a swift action, a ganzi can transform one of their limbs into a natural melee weapon that deals 1d6 points of damage, can deal B or S or P your choice when it manifests, and counts as chaotic for bypassing damage reduction. The transformation lasts until the beginning of the ganzi’s next turn. Every 6 levels this natural attack has its damage step increased by 1.",
            },
            {
                name:"Ink(Ex)",
                description:"Once per day, plus one additional time per day for every 4 Hit Dice, the ganzi can spit a stream of opaque black ink from their mouth. The ganzi can target either a creature or a square on the ground, each with different effects. Creature: The ganzi shoots a stream of ink into a creature’s eyes as a ranged touch attack with a range of 30 feet. If the ganzi hits, the target must succeed at a Fortitude saving throw (DC = 10 + half the ganzi’s Hit Dice + the ganzi’s Constitution modifier) or be blinded for 1d4 rounds. Ground: The ganzi spits the ink into a single square on the ground within 30 feet, which becomes slippery for 1d6 rounds. Any creatures entering the square must succeed at a Reflex save (DC = 10 + half the ganzi’s Hit Dice + the ganzi’s Constitution modifier) or fall prone.",
            },
            {
                name:"Racing Mind(Ex)",
                description:"The ganzi’s churning vortex of thoughts bolsters it against mental attacks, granting the ganzi a +2 bonus on Will saves against mind-affecting effects.",
            },
            {
                name:"Irrepressible(Ex)",
                description:"Your contrary nature means you bounce back with prejudice. When you gain a +2 bonus on saves against a emotion or fear effects. If you are rerolling (using the built in Akashic Paths rerolling rule) against an ongoing emotion or fear effect, it only requires a standard action instead of a full-round action.",
            },
            {
                name:"Uncanny Aura(Su)",
                description:"Once per day as a standard action, such a ganzi can activate an uncanny aura; enemies within 30 feet must succeed at a Will saving throw (DC = 10 + HD/2 + the ganzi’s Charisma modifier) or become frightened until the beginning of the ganzi’s next turn. The aura remains for a number of rounds equal to the ganzi’s Charisma modifier (minimum 1 round). Once a creature has been affected by an uncanny aura, whether it failed its save or not, it cannot be affected again for 24 hours. This ability ONLY scales with charisma.",
            },
            {
                name:"Vestigial Wings(Ex)",
                description:"Though these appendages do not grant flight, but the they do provide additonal balance on the ground, and in the air. Such ganzis gain a +2 bonus on Reflex saving throws and a +4 bonus on Acrobatics and fly and treats all falling damage as if it was 10 feet shorter.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.skills.acrobatics += 4
                    context.stats.characterStats.skills.fly += 4
                    context.stats.characterStats.misc.reflex += 2
                }
            },
            {
                name:"Void Touch(Su)",
                description:"Once per combat when such a ganzi hits a creature with a melee attack, the ganzi can deliver a burst of chaos to that creature as a free action. The target must succeed at a Will save (DC = 10 + HD/2 + the ganzi’s Constitution modifier) or be confused for 1 round.",
            },
            {
                name:"Abnormal Physiology(Ex)",
                description:"Once per day when you are about to receive a critical hit or precision damage, as an immediate action you can gain fortification 100% for 1 round. This lasts an additional round every 8 HD.",
            },
            {
                name:"Protean Eyes(Ex)",
                description:"You gain darkvision and low-light vision.",
            },
            {
                name:"Physical Mutation(Ex)",
                description:"Gain a +4 to a random physical ability score",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let scores = ["strength","constitution","dexterity"]
                    let score = scores[Math.floor(Math.random()*3)]
                    context.stats.characterStats.abilityScore[score] += 4
                }
            },
            {
                name:"Choatic Form(Ex)",
                description:"At the start of each floor roll 4d6, the first d6 represents an ability score (from top to bottom on the sheet), gain a bonus on that score equal to the result of the second d6. The 3rd d6 represents also represtents a score (determined the same way), get a penalty to that ability score equal to the result. These bonuses and penalties last until the end of the floor.",
            },
            {
                name:"Let Fate Decide",
                description:`While in combat as a free action at the start of your turn you can allow fate to decide your actions, roll a 1d8, each result determining an action. You must take that action on your turn or you become confused for 1d4 rounds. Each of the actions has a bonus associated with it, you can take any other actions on your turn. If you succeed on the action dictated, you restore your charisma modifier spell points (Only Charisma).
                \n1 Attack a Creature: Gain +2 to attack and damage\n2 Cast a Spell: Costs 25% less spell points\n3 Roll a skill check: Gain +4 to the check\n4 Move: must move at least your movement speed or take a move action to move \n5 Grab an Item: You can withdraw and use the item as a standard action\n6 Take no action: Requires a standard action, restore level/2 spell point\n7 Fall Prone: You gain a +6 dodge bonus to your armor class for 1 round \n8 Roll a natural 20: If you actually roll a natural 20 you gain a +2 luck bonus on all d20 rolls for 5 rounds, and restore level hit points and spell points.`,
            },
        ]
    },
    {
        rarity:"class",
        name:"Skinwalker",
        longDesc:`Skinwalkers appear human, however they have the ability to assume a beastial shape.
        \nAbility Scores: +1 Wisdom, -2 intelligence, -1 charisma
        \nDefenses: None
        \nSkills: +4 Survival, +2 Perception, Knowledge Nature, -4 diplomacy,
        \nSpecial: You gain a beastwalker heritage, each modifies your stats further. Additionally, you can transform into your beastial shape, gaining different bonuses. Transforming is a standard action and lasts until you choose for it to end. You can only maintain your beastial shape for rounds equal to your constitution score -10 each day. Temporary changes to your constitution do not change its duration.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision
        \nBonus Rolls: Gain a maneuver from Golden Lion/Iron Tortoise/Primal Fury/Silver Crane/Steel Serpent at level 1 and every 6 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level %6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{goldenLion:true,ironTortoise:true,primalFury:true,silverCrane:true,steelSerpent:true}}}))
            }
        },
        catchUpMethod:(context, self)=>{
            self.getChoice(context,self)
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.intelligence -= 2
            context.stats.characterStats.abilityScore.charisma -= 1  
            context.stats.characterStats.skills.survival += 4
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.knowNature += 2
            context.stats.characterStats.skills.diplomacy -= 4
            context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{goldenLion:true,ironTortoise:true,primalFury:true,silverCrane:true,steelSerpent:true}}}))
        },
        getChoice: (context,self)=>{
            let heritages = self.heritages
            let rare = {
                name:"Werehouse",
                description:`You gain +2 strength, +1 constitution, +1 natural armor. \n\nWhen transformed you increase by one size, gaining the bonuses and penalties as if you had enlarge person cast on you. You also gain DR 5/slashing, and a further +1 natural armor bonus.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 2
                    context.stats.characterStats.abilityScore.constitution += 1
                    context.stats.statsForAbilities.ac.natural += 1
                }
            }
            let choices = []
            if(Math.random() > 0.75){
                heritages.push(rare)
            }
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*heritages.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*heritages.length)
                chosen.push(possible)
                let option = heritages[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Skinwalker")[0]
                        perk.longDesc += `\n\nHeritage: ` + option.name + ": " + option.description
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                        }
                    })
                }
            }
            
            let custom = {title:"Skinwalker Heritage", options:choices}         
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            return self.heritages
        },
        heritages:[
            {
                name:"Werebat",
                description:`You gain +2 Dexterity, +2 acrobatics, perception, and +4 fly. \n\nWhen transformed you gain +2 intelligence, blindsense 10 feet, and a primary bite attack that deals 1d6 damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.acrobatics += 2
                    context.stats.characterStats.skills.perception += 2
                    context.stats.characterStats.skills.fly += 4                        
                }
            },
            {
                name:"Werebear",
                description:`You gain +2 constitution, +4 climb, +4 diplomacy, and +2 to CMD vs grapple and bull rush attempts. \n\nWhen transformed you gain +2 strength, +2 natural armor, a primary bite attack that deals 1d6 damage, and 2 primary claw attacks that deal 1d4 damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.climb += 4
                    context.stats.characterStats.skills.diplomacy += 4
                }
            },
            {
                name:"Werecrocodile",
                description:`You gain +2 constitution, +4 swim, +4 stealth, +1 natural armor. \n\nWhen transformed you gain +2 strength, the ferocity ability, a swim speed of 30 feet, and a primary bite attack that deals 1d10 damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.stealth += 4
                    context.stats.characterStats.skills.swim += 4
                    context.stats.statsForAbilities.ac.natural += 1
                }
            },
            {
                name:"Wereboar",
                description:`You gain +2 strength, -2 charisma, +4 intimidate, +2 perception, -4 stealth, -8 diplomacy and bluff. \n\nWhen transformed you gain +2 strength, +10 feet to your movement speed, a primary gore attack that deals 1d6 damage, 2 secondary hoof attacks that deal 1d4 damage. When transformed your armor class lowers by -2, if you are raging when transformed you can choose to increase your strength by a further +2, but it reduces your armor class by a further -4.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 2
                    context.stats.characterStats.abilityScore.charisma -= 2
                    context.stats.characterStats.skills.intimidate += 4
                    context.stats.characterStats.skills.perception += 2
                    context.stats.characterStats.skills.stealth -= 4
                    context.stats.characterStats.skills.diplomacy -= 8
                    context.stats.characterStats.skills.bluff -= 8
                }
            },
            {
                name:"Wererat",
                description:`You gain +2 intelligence, +4 stealth, -4 diplomacy. \n\nWhen transformed you gain +2 dexterity, a climb speed of 15 feet, a primary bite attack that deals 1d4 damage, and creatures struck by it must make a fortitude save DC 10 + HD/2 + con mod or become nauseated for 1 round, this is a disease and poison effect. When attacking a creature that is currently flanked you gain +1 to the attack.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.intelligence +=2
                    context.stats.characterStats.skills.stealth += 4
                    context.stats.characterStats.skills.diplomacy -= 4
                }
            },
            {
                name:"Wereraptor",
                description:`You gain +2 dexterity, and +4 acrobatics, +2 stealth, and +2 sense motive. \n\nWhen transformed you gain +2 wisdom, +1 natural armor bonus, you can ignore 5 feet of difficult terrain while charging, a primary bite attack that deals 1d6 damage and two secondary talon attacks that deal 1d4 damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.stealth += 2
                    context.stats.characterStats.skills.senseMotive += 2
                    context.stats.characterStats.skills.acrobatics += 4
                }
            },
            {
                name:"Wereshark",
                description:`You gain +2 wisdom, and +4 swim and perception. \n\nWhen transformed you gain +2 strength, a swim speed of 30 feet, a scent of 30 feet, a primary bite attack that deals 1d8 damage. If you attack a creature that is currently bleeding within your scent range you gain +1 to attack and +2 to damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.wisdom += 2
                    context.stats.characterStats.skills.swim += 4
                    context.stats.characterStats.skills.perception += 4
                }
            },
            {
                name:"Weretiger",
                description:`You gain +2 dexterity, +4 acrobatics and +4 perception. \n\nWhen transformed you gain +2 strength, your movement speed increases by 10 feet when running or charging, and a primary bite attack that deals 1d6 damage and two primary claw attacks that deal 1d4 damage. You gain +1 attack on charge attacks.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.acrobatics += 4
                    context.stats.characterStats.skills.perception += 4
                }
            },
            {
                name:"Werewolf",
                description:`You gain +2 constitution, +4 perception, and +1 racial bonus to all saving throws. \n\nWhen transformed you gain +2 wisdom, a primary bite attack that deals 1d6 damage and two primary claw attacks that deal 1d4 damage, and a +4 bonus to trip attempts.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.perception += 4
                    context.stats.characterStats.misc.will += 1
                    context.stats.characterStats.misc.reflex += 1
                    context.stats.characterStats.misc.fortitude += 1
                }
            },                
            {
                name:"Wereturtle",
                description:`You gain +2 constitution, +2 natural armor, +4 heal, +2 stealth, +2 survival, your movement speed is reduced to 20 feet, however armor no longer slows your movement speed. \n\nWhen transformed you gain +2 wisdom, a further +2 bonus to your natural armor, and a swim speed of 20 feet.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.heal += 4
                    context.stats.characterStats.skills.stealth += 2
                    context.stats.characterStats.skills.survival += 2
                    context.stats.statsForAbilities.ac.natural += 2
                }
            },
            {
                name:"Werespider",
                description:`You gain +2 dexterity, +4 stealth, +4 climb, +2 disable device, and +2 bonus on saves against mind-affecting effects. \n\nWhen transformed you gain +2 constitution, +1 natural armor, a secondary bite attack that deals 1d4 damage and inflicts poison, a +4 bonus on your CMD against trips and bullrushes and as a bonus to grapple checks, and a climb speed of 20 feet. \npoison[injury, fort DC=(10+HD/2+con mod), frequency 1/round for 4 rounds, effect 1d2 strength damage, cure 1 save]`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.stealth += 4
                    context.stats.characterStats.skills.climb += 4
                    context.stats.characterStats.skills.disableDevice += 2
                }
            },
            {
                name:"Werefox",
                description:`You gain +1 charisma, +1 dexterity, +1 intelligence, +4 stealth, +4 bluff, +2 diplomacy, and +2 escape artist. \n\nWhen transformed you gain +2 intelligence or charisma, your choice, a primary bite attack that deals 1d4 damage, you also gain +2 dodge bonus against attacks of opportunity.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 1
                    context.stats.characterStats.abilityScore.intelligence += 1
                    context.stats.characterStats.abilityScore.charisma += 1
                    context.stats.characterStats.skills.stealth += 4
                    context.stats.characterStats.skills.bluff += 4
                    context.stats.characterStats.skills.diplomacy += 2
                    context.stats.characterStats.skills.escapeArtist += 2                
                }
            },
            {
                name:"Werejackal",
                description:`You gain +2 charisma, +4 spellcraft, and +4 knowledge arcana. \n\nWhen transformed you gain +2 dexterity, a primary bite attack that deals 1d6 damage, and you gain damage reduction 3/cold iron.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.charisma += 2
                    context.stats.characterStats.skills.spellcraft += 4
                    context.stats.characterStats.skills.knowArcana += 4
                }
            },
            {
                name:"Weremantis",
                description:`You gain +2 dexterity, +6 stealth, +4 acrobatics. \n\nWhen transformed you gain +2 dexterity, a +2 bonus on saves vs mind-effecting effects, and 2 primary claw attacks that deal 1d6 damage, these claw attacks have twice your normal natural reach, however you cannot make attacks of opportunity with them. Whenever you succeed on a grapple check you can make an attack of opportunity with your claw.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.stealth += 6
                    context.stats.characterStats.skills.acrobatics += 4
                }
            },
            {
                name:"Werewasp",
                description:`You gain +2 constitution, +6 intimidate, +4 fly, -4 stealth, -8 diplomacy. \n\nWhen transformed you gain +2 dexterity, +1 natural armor, a +2 to saves vs mind-effecting effects, and primary sting attacks that deal 1d4 damage, that applies a poison, DC = 10 + HD/2 + con mod, dealing 1d2 point of dexterity damage for 4 rounds.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.intimidate += 6
                    context.stats.characterStats.skills.fly += 4
                    context.stats.characterStats.skills.stealth -= 4
                    context.stats.characterStats.skills.diplomacy -= 8
                }
            },
            {
                name:"Weregorilla",
                description:`You gain +2 strength, +4 survival, +2 CMD and CMB. \n\nWhen transformed you gain +2 wisdom, +1 natural armor, and the damage with all of your melee weapons increases by 1 dice step.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 2
                    context.stats.characterStats.skills.survival += 4
                    // context.stats.tempModifiers.cmb += 2
                    // context.stats.tempModifiers.cmd += 2
                }
            },
            {
                name:"Werebull",
                description:`You gain +2 strength, +6 intimidate, -8 sense motive. \n\nWhen transformed you gain +2 strength, and a primary gore attack that deals 1d6 damage, whatever bonus to attack you gain from charging, you also gain to the attack's damage, if you charge with your gore attack, it instead gains double the bonus to its damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 2
                    context.stats.characterStats.skills.intimidate += 8
                    context.stats.characterStats.skills.senseMotive -= 8
                }
            },
            {
                name:"Werecrab",
                description:`You gain +2 wisdom, +4 intimidate, +4 sense motive, and +1 to will saves. When you are the only creature threatening an enemy you gain a +2 bonus to attacks against it. \n\nWhen transformed you gain +2 strength, +2 natural armor, and 2 primary claw attacks that deal 1d6, each has the grab ability.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.wisdom += 2
                    context.stats.characterStats.skills.intimidate += 4
                    context.stats.characterStats.skills.senseMotive += 4
                    context.stats.characterStats.misc.will += 1
                }
            },
            {
                name:"Weredactyl",
                description:`You gain +2 wisdom, +4 fly. \n\nWhen transformed you gain +2 strength, a primary bite attack that deals 1d6 damage, and a fly speed of 30 feet (poor).`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.wisdom += 2
                    context.stats.characterStats.skills.fly += 4
                }
            },
            {
                name:"Weregecko",
                description:`You gain +2 constitution, +4 climb, +2 stealth, +2 bluff, +2 escapeArtist \n\nWhen transformed you gain +2 dexterity, a climb speed of 30 feet, and when you would be reduced below 0 hit points from an attack, you can shed your tail, this deals 2 points of constitution damage to you and 1 point of constitution drain, but negates the damage from the attack that would reduce you below 0 hit points. You cannot shed your tail again until the constitution damage from this ability is healed.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.climb += 4
                    context.stats.characterStats.skills.stealth += 2
                    context.stats.characterStats.skills.bluff += 2
                    context.stats.characterStats.skills.escapeArtist += 2
                }
            },
            {
                name:"Werebunny",
                description:`You gain +2 dexterity, -2 intelligence, +8 acrobatics, +6 escape artist, +2 diplomacy, -8 survival, \n\nWhen transformed you gain +1 charisma and +2 dexterity, +2 bonus to reflex saves, and you double the result of your acrobatics checks made to jump. The distance you move when making an acrobatics check to long jump is no longer limited by your movement speed, however you always move the maximum distance from your check, meaning you may not end up where you desire. When you high jump the height you jump is equal to half the result of your acrobatics check.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.abilityScore.intelligence -= 2
                    context.stats.characterStats.skills.acrobatics += 8
                    context.stats.characterStats.skills.escapeArtist += 6
                    context.stats.characterStats.skills.diplomacy += 2
                    context.stats.characterStats.skills.survival -= 8
                }
            },
            {
                name:"Weresnail",
                description:`You gain +2 wisdom, -4 dexterity, +6 sense motive, +2 climb, +2 natural armor, -6 acrobatics, and your movement speed reduces to 20 feet. \n\nWhen transformed you gain +2 bonus to your constitution, a further +2 bonus to your natural armor bonus, and as a movement action you can hide in your shell, doing this stops you from taking any other action except purely mental actions or leaving, which you can do as a swift action. While you are hiding in your shell your natural armor bonus increases by a further +4, and you dont have line of effect or sight to anything except yourself.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.wisdom += 2
                    context.stats.characterStats.abilityScore.dexterity -= 4
                    context.stats.characterStats.skills.senseMotive += 6
                    context.stats.characterStats.skills.climb += 2
                    context.stats.characterStats.skills.acrobatics -= 6
                    context.stats.statsForAbilities.ac.natural += 2
                }
            },
            {
                name:"Wererhino",
                description:`You gain +2 constitution, -6 perception, +2 climb, and +1 natural armor\n\nWhen transformed you gain +2 bonus to your constitution, a further +1 bonus to your natural armor bonus, and a primary gore attack that deals 1d8 damage. When you charge your gore attack deals 2d8 damage.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 2
                    context.stats.characterStats.skills.senseMotive += 6
                    context.stats.characterStats.skills.climb += 2
                    context.stats.characterStats.skills.acrobatics -= 6
                    context.stats.statsForAbilities.ac.natural += 2
                }
            }, 
        ]
        
    },
    {
        rarity:"class",
        name:"Mysthral",
        longDesc:`Mysthrals are a collection of half-human half-animal hybrids, but unlike most other animal hybrids, their animalistic features come from their connection to ancient spiritual energies. This connection also make them very powerful spell casters, and they have many abilities that compliment spell casting.
        \nAbility Scores: +1 Dexterity, +1 Wisdom, +2 Charisma, -2 intelligence, -1 strength
        \nDefenses: You gain a +2 bonus on saves against enchantments and a +4 bonus on saves against illusions.
        \nSkills: +4 Diplomacy, Bluff, Knowledge Nature, heal, +2 Survival, Perception, Spellcraft, Stealth, -6 Knowledge Religion, -8 disable device, -12 craft
        \nSpecial: Gain a special Mysthral power. Mysthrals cannot use firearms. Gain 10 universal spell power and 2% spell critical chance, but -20 negative spell power and -4% negative spell critical chance.
        \nSize: medium
        \nSpeed: 30 feet
        \nVision: Low-light Vision
        \nBonus Rolls: Gain an additional Mysthral power every 8 levels.`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level %8 == 0){
                self.getChoice(context, self)
            }
        },
        catchUpMethod:(context, self)=>{
            self.getChoice(context,self)
            context.stats.characterStats.abilityScore.wisdom += 1
            context.stats.characterStats.abilityScore.charisma += 2
            context.stats.characterStats.abilityScore.dexterity += 1
            context.stats.characterStats.abilityScore.intelligence -=2
            context.stats.characterStats.abilityScore.strength -= 1
            context.stats.characterStats.skills.diplomacy += 4
            context.stats.characterStats.skills.bluff += 4
            context.stats.characterStats.skills.heal += 4
            context.stats.characterStats.skills.knowNature += 4
            context.stats.characterStats.skills.survival += 2
            context.stats.characterStats.skills.perception += 2
            context.stats.characterStats.skills.spellcraft += 2
            context.stats.characterStats.skills.stealth += 2
            context.stats.characterStats.skills.knowReligion -= 6
            context.stats.characterStats.skills.disableDevice -= 8
            context.stats.characterStats.skills.craft -= 12
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
            context.stats.characterStats.spellMastery.spellPower.universal += 10
            context.stats.characterStats.spellMastery.spellPower.negative -= 20
            context.stats.characterStats.spellMastery.spellCriticalChance.negative -= 4
            let perk = context.stats.lists.perks.filter(perk => perk.name == "Mysthral")[0]
            perk.longDesc += `\n\nPowers: ` 
        },
        getChoice: (context,self)=>{
            let heritages = self.heritages
            let rares = [
                {
                    name:"Spiritstep",
                    description:`You can use your highest mental stat instead of dexterity to determine your armor class`,                             
                },
                {
                    name:"Wild Magic",
                    description:`gain 5% universal spell critical chance and 20% spell critical damage`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.spellMastery.spellCriticalChance.universal += 5
                        context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 20
                    }
                },
                
            ]
            let choices = []
            if(Math.random() > 0.75){
                heritages.concat(rares)
            }
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*heritages.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*heritages.length)
                chosen.push(possible)
                let option = heritages[possible]                    
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Mysthral")[0]
                        perk.longDesc += `\n` + option.name + ": " + option.description +`\n`
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                        }
                    })
                }
            }
            
            let custom = {title:"Mysthral Power", options:choices}         
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            return self.heritages
        },
        heritages:[
            {
                name:"Spirit Rush(Sp)",
                description:`Once per day you activate spirit rush as a movement action, allowing you to teleport 15 feet. Then, spirit rush remains active for 4 rounds, during that duration you can spend a movement action to teleport again, but not more than once per round, each time you do the distance you travel increases by 15 feet. If you kill a creature during the duration of spirit rush you gain the ability to teleport one more time during its duration, its duration increases by 1 round, and you heal hit points equal to your highest mental score.`,                    
            },
            {
                name:"Spirit Magic",
                description:`You gain an additional 10 universal spell power and 2% universal spell critical chance, but -20 negative spell power and -4% negative spell critical chance.`,    
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.universal += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
                    context.stats.characterStats.spellMastery.spellPower.negative -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.negative -= 4
                }
            },
            {
                name:"Essence Theft(Su)",
                description:`Whenever a creature dies within 15 feet of you, you restore level/2 spell points (minimum 1).`,                    
            },
            {
                name:"Spirit Sight",
                description:`You gain blindsense 10 feet and you can see creatures on the ethereal plane.`,                    
            },
            {
                name:"Spirit Guardian",
                description:`Whenever you would be healed hit points through magical healing, you can choose to redirect some of that healing to an ally within 15 feet of you instead of gaining it yourself. Any healing redirected this way is only 50% effective.`,                             
            },
            {
                name:"Spirit Armor",
                description:`As a swift action you can gain a deflection bonus to your armor class equal to your highest mental stat for the next attack against you within 1 minute.`,                             
            },            
            {
                name:"Life Leach",
                description:`Whenever a creature dies within 20 feet of you, you heal level hit points.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.acrobatics += 2
                    context.stats.characterStats.skills.perception += 2
                    context.stats.characterStats.skills.fly += 4                        
                }
            },
            {
                name:"Otherworldly Charm",
                description:`Gain +2 bluff and diplomacy and gain the charm person spell. At level 6 you gain charm monster as well. Your compulsion spells gain a +1 bonus to their DC's and your charm spells gain a +2 to their DC's (this doesn't stack).`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Charm Person")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Charm Monster")[0])
                    context.stats.characterStats.skills.bluff += 2
                    context.stats.characterStats.skills.diplomacy += 2
                }
            },
            {
                name:"Spirit Prowler",
                description:`Gain the Vanish spell. Once per day you can cast it as a swift action. This ability recharges whenever you suffer a critical hit. At level 12 you gain greater invisibility and can use it with this ability, however you can only target yourself with it.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Vanish")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Invisibility, Greater")[0])
                }
            },
            {
                name:"Blossoming Spirit",
                description:`At the start of each floor you gain temporary hit points equal to your level. At level 6 you can choose for this to instead give temporary hit points equal to your highest mental score. These last the rest of the floor. At level 11 you also gain 1/4 the amount at the start of each combat, however they only last 3 rounds, and do not stack with each other. On any fey, first world, or spirit themed map these are doubled.`,                    
            },
            {
                name:"Trickster",
                description:`Gain 'Mirror Image' and Silent 'Image' spells. The caster level and DC for your illusion spells increase by +1.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Mirror Image")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Silent Image")[0])
                }
            },
            {
                name:"Lover's Leap",
                description:`Twice per day as a swift action you can move 10 feet towards an ally within 10 feet, ending your movement in a square adjacent to them, this movement does not provoke attacks of opportunity. When you do, both you and the ally gain your highest mental score, or constitution score, whichever is highest as temporary hit points that last 1 round. Each time in a run you activate this on an ally you have already activated it on, the range and the distance you move increases by 5 feet.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.acrobatics += 2
                    context.stats.characterStats.skills.perception += 2
                    context.stats.characterStats.skills.fly += 4                        
                }
            },
            {
                name:"Gaia's Blessing",
                description:`Gain 20 positive spell power and 2% positive spell critical chance.`,                    
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                }
            },
            {
                name:"Guile's Glee",
                description:`Whenever an illusion spell you cast causes a creature to miss an attack, they take 1 point of damage and you heal 1 hit point. Every 4 levels this increases by 1 point of damage and 1 hit point.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.dexterity += 2
                    context.stats.characterStats.skills.acrobatics += 2
                    context.stats.characterStats.skills.perception += 2
                    context.stats.characterStats.skills.fly += 4                        
                }
            },
            {
                name:"Ferocious",
                description:`Gain +4 strength, +1 constitution, and -2 intelligence and -3 charisma.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 4
                    context.stats.characterStats.abilityScore.constitution += 1
                    context.stats.characterStats.abilityScore.charisma -= 3
                    context.stats.characterStats.abilityScore.intelligence -= 2
                }
            },
            {
                name:"Spirit Resilience",
                description:`Gain a +2 bonus to will and fortitude saves.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.misc.will += 2
                    context.stats.characterStats.misc.fortitude += 2
                }
            },
            {
                name:"Mysthral's Skin",
                description:`Gain DR 3/cold iron. This can stack with other sources of damage reduction.`,                    
            },
            {
                name:"Ancestral Knowledge",
                description:`Gain 3 spells`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"})); 
                }
            },
            {
                name:"Spiritwell",
                description:`Gain +1 spell point per level, and +6 spell points`,
                hasCustomMethod:true,
                customMethod:(context)=>{                        
                    context.stats.characterStats.spellpointIncreases.push(6)
                    context.stats.characterStats.misc.spPerLevel += 1                     
                }
            },
            {
                name:"Ferverant Follower",
                description:`When you cast a buff spell you can increase a single numerical modifier granted by the spell by +1, but as long as the buff remains the creature receives a -2 penalty to all saves.`,                    
            },
            {
                name:"Mind Twisting Magic",
                description:`Once per day when casting a spell, you spend a swift action to alter the spell, causing it to also count as a control spell. When a creature would be effected by the spell they must also make a will save DC equal to the spells DC or become charmed (as charm monster) for rounds equal to the level of the spell (immunity to charm monster also grants immunity to this). Once a creature is targeted by this ability, whether it succeeds or fails the save, it cannot be affected by it again.`,                    
            },
            {
                name:"Feast on Feelings",
                description:`When a creature is currently under the effect of a charm or compulsion effect that you created, they take your level damage at the start of each of their turns and you gain temporary hit points equal to half the amount of damage dealt. These temporary hit points stack up to your hit dice * 4.`,                    
            },
            {
                name:"Soul-Link",
                description:`Once per day as a standard action you bestow a kiss to an adjacent ally, for the next 4 rounds that creature can use your spell points as if they were their own.`,                    
            },
            {
                name:"Treacherous Bargain",
                description:`As a standard action you bestow a kiss to an adjacent ally granting them your boon, they gain a +2 inherent bonus to whichever ability score is your highest (when activated). In response to any effect against you that you are aware of you can use an immediate action to transfer the effect to the target of your boon. This even includes hit point damage or spell point cost, but not death. The target of your boon must be alive for you to activate this, but doesn't need to be willing. Once you activate this ability your boon on the creature ends and they take a permanent -4 reduction to the ability score you increased. A creature can never have your boon again once lost and you can only have a single boon active at a time. You can as a standard action give a creature currently blessed by your boon another kiss changing the bonus they are gaining to your highest ability score.`,                    
            },
            {
                name:"Spirit Fire(Sp)",
                description:`You gain the ability to form and throw a ball of spirit fire as a standard action. It has a range of 25ft + 5ft/2 levels and deals 1d6 + highest mental damage. It requires a ranged touch attack and deals half fire damage half untyped damage. Using this ability counts as casting a level 1 damage spell with the fire subtype.`,                    
            },
            {
                name:"Soul Scorch(Su)",
                description:`If a creature ever fails a save against a spell you cast, they take 1d6 points of damage. Every 6 levels this increases by 1d6.`,                    
            },  
            {
                name:"Surging Spirit",
                description:`When you cast a buff spell on a target it gains a +5 enhancement bonus to its movement speed per level of the spell. Each round this movement speed decreases by 10 feet until it reaches 0.`,                    
            },
            {
                name:"Shapeshifter",
                description:`At level 1 you gain the alter self spell, at level 7 you gain beastshape I, at level 11 you gain beastshape II, at level 15 you gain beastshape III`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Alter Self")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Beast Shape I")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Beast Shape II")[0])
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Beast Shape III")[0])
                                 
                }
            },            
            {
                name:"Regather Essence",
                description:`Once per day as an swift action you can gain temporary hit points equal to half the hit points you lost on the previous round, these last 3 rounds, then you can also make an additional saving throw against a single currently ongoing effect.`,                    
            },
            {
                name:"Misdirection",
                description:`Once per combat when you are targeted by an attack, you can as an immediate action roll a bluff check vs the attack roll as the DC, if you succeed the attack is negated and the creature is feinted for 1 round.`,                    
            },
            {
                name:"Spirit Dancer",
                description:`Your performance skill increases by +6. You can use performance in place of bluff or intimidate rolls.`,
                hasCustomMethod:true,
                customMethod:(context)=>{                        
                    context.stats.characterStats.skills.perform += 6                       
                }
            },
            {
                name:"Heart of Gaia",
                description:`As a swift action you cause yourself to become immune to hit point damage for 1 round. You can only use this ability once, however it recharges any time you die.`,                    
            },
            {
                name:"Shapesplitter(Sp)",
                description:`For 3 spell points as a swift action you create an illusion of yourself, which moves 25 feet in a direction of your choosing then vanishing, any creature that threatens it during its movement must succeed a will save DC 10+ level/2 + highest mental or make an attack of opportunity against the image. No attack against it will ever strike it. This counts as a utility illusion spell. If a creature makes an attack of opportunity against your illusion and you move through its threatened space on the same turn you can roll a bluff check to feint it as a free action.`,                    
            },
            {
                name:"Dirty Trickster",
                description:`You gain improved dirty trick as a bonus feat. When you succeed on a dirty trick or feint against an enemy, instead of inflicting any sort of penalty on the creature you can regain highest mental modifier spell points. If you gain this a second time you can inflict the penalty and restore spell points at the same time.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Improved Dirty Trick")[0])
                }
            },
            {
                name:"Irresistable(Sp)",
                description:`All creatures count you as being something they are attracted to, regardless of any reason they wouldn't or couldn't be. Additionally once per day as a standard action you can emit a charming aura, all creatures within 30 feet must make a will save DC 10 + level/2 + highest mental or they become charmed by you (as charm monster), this lasts until the end of their next turn, and they must end their turn adjacent to you or become staggered for 1d3 round. This is a mind-affecting affect, and counts as a charm and control spell.`,                
            },
            {
                name:"Encouragement(Su)",
                description:`As a standard action you can encourage an ally within 30 feet, that ally gets a +2 morale bonus on their next roll within 1 minute. Every 10 levels you can target an additional ally. If you use the aid another action you increase the bonus you give by +1, however this additional +1 is a morale bonus. Once during a run you can make a promise to a party memeber that is able to hear you as an immediate action when they are reduced below 0 hit points, roll a bluff or diplomacy check against their sense motive, if you succeed they become immune to the dying and dead condition for 1 round. Increase the duration by 1 round for every 10 you beat their sense motive check.`,                
            },
        ]
        
    },
]